function debounce(e, t, r) {
  var n;
  return function () {
    var l = this,
      o = arguments,
      a = function () {
        (n = null), r || e.apply(l, o);
      },
      u = r && !n;
    clearTimeout(n), (n = setTimeout(a, t)), u && e.apply(l, o);
  };
}
function getRandomInt(e, t) {
  return Math.floor(Math.random() * (t - e + 1) + e);
}
function closeModal(e, t = !1) {
  t ||
    (t =
      e.currentTarget.closest("[data-bstr-modal]") ||
      e.currentTarget.closest(".modal")),
    (t.style.display = "none");
}
const isUndefined = (e) => typeof e == "undefined";
Element.prototype.closestEl = function (e) {
  for (var t = this.parentElement; t; ) {
    if (t.matches(e)) return t;
    var r = t.querySelectorAll(e);
    for (let n = 0, l = r.length; n < l; ++n)
      if (r[n] != null && r[n] != this) return r[n];
    t = t.parentElement;
  }
  return null;
};
class BstrEvents {
  constructor() {
    (this.listeners = {}), (this.logs = {});
  }
  on(s, t) {
    if (typeof t != "function")
      throw "[BOOSTER EVENT] Callback must be a function. Event: " + s;
    this.logs[s] && t.call(t, this.logs[s]),
      typeof this.listeners[s] == "undefined"
        ? (this.listeners[s] = [t])
        : this.listeners[s].push(t);
  }
  trigger(s, t = {}, f = !1) {
    let l = this.listeners[s],
      r = document.dispatchEvent(
        new CustomEvent(s, {
          detail: t,
          cancelable: s.includes(":b*"),
          bubbles: !0,
        })
      ),
      i = [r];
    if (l && l.length) {
      let n = !r;
      for (let o of l)
        try {
          let e = o.call(o, { ...t, prevented: n });
          typeof e != "undefined" && (i.push(e), n !== !0 && (n = e === !1));
        } catch (e) {
          console.info(`[BOOSTER EVENTS] Error caught on ${s}.
${e}`);
          continue;
        }
    }
    return f && (this.logs[s] = t), { values: i, prevent: i.includes(!1) };
  }
}
class BstrNotify {
  constructor({ events: e }) {
    (this.events = e),
      (this.popupHolder = document.getElementById("booster__popup--holder")),
      this.events.on("booster:notify", this.fn.bind(this));
  }
  fn(e) {
    var i = this,
      s;
    e.url
      ? ((s = document.createElement("a")),
        (s.href = e.url),
        (s.target = "_blank"))
      : (s = document.createElement("div")),
      e.id && (s.dataset.id = e.id);
    const r = function () {
      if (this.dataset.id) {
        let t = bstore.get("bstr_notifs") || {},
          o = t.dismissed || [];
        o.push(this.dataset.id),
          (t.dismissed = o),
          bstore.set("bstr_notifs", t, 120);
      }
      this.parentElement.removeChild(this);
    };
    s.setAttribute("class", "booster__popup booster__popup--" + e.type),
      (s.innerText =
        typeof e.message == "string" ? e.message : JSON.stringify(e.message)),
      i.popupHolder.appendChild(s),
      (s.onclick = r),
      s.classList.add("anim__fade-in"),
      e.expires !== !1 &&
        setTimeout(function () {
          try {
            i.popupHolder.removeChild(s);
          } catch (t) {}
        }, e.expires || 5e3);
  }
}
class BstrCart {
  constructor({ events: t, basync: a }) {
    if (!_lazyInit) return;
    (this.events = t),
      (this.basync = a),
      (this.queue = []),
      (this.awaitingSuccess = []),
      (this.listeners = []),
      (this.minicart = { lastUpdate: 0 }),
      (this.cartSuccessConfig = { action: _settings.cartAction }),
      (this.cartSuccessInfoTemplate =
        (document.querySelector(".add-to-cart__success--single-current") &&
          document.querySelector(".add-to-cart__success--single-current")
            .innerHTML) ||
        !1);
    let e = document.querySelectorAll("[data-cart-container]");
    for (let s = 0, i = e.length; s < i; ++s) this.addListener(e[s]);
    this.dispatchListeners(), this.bindXHRFetch();
  }
  bindXHRFetch() {
    const t = this,
      a = window.XMLHttpRequest.prototype.open;
    function e() {
      return (
        this.addEventListener("load", function () {
          try {
            let s = new URL(this._url);
            s.origin == window.location.origin &&
              [
                "/cart/add.js",
                "/cart/update.js",
                "/cart/change.js",
                "/cart/clear.js",
              ].includes(s.pathname) &&
              t.dispatchListeners({ change: !0 });
          } catch (s) {
            try {
              [
                "/cart/add.js",
                "/cart/update.js",
                "/cart/change.js",
                "/cart/clear.js",
              ].includes(this._url) && t.dispatchListeners({ change: !0 });
            } catch (i) {
              console.log("[BOOSTER THEME] Invalid URL format caught in XHR.");
            }
          }
        }),
        a.apply(this, arguments)
      );
    }
    (window.XMLHttpRequest.prototype.open = e),
      (function (s, i) {
        typeof i == "function" &&
          (s.fetch = function () {
            const r = i.apply(this, arguments);
            return (
              r.then((c) => {
                try {
                  let n = new URL(c.url);
                  n.origin == window.location.origin &&
                    [
                      "/cart/add.js",
                      "/cart/update.js",
                      "/cart/change.js",
                      "/cart/clear.js",
                    ].includes(n.pathname) &&
                    t.dispatchListeners({ change: !0 });
                } catch (n) {
                  console.log(
                    "[BOOSTER THEME] Invalid URL format caught in fetch."
                  );
                }
              }),
              r
            );
          });
      })(window, window.fetch),
      window.addEventListener("storage", (s) => {
        s.key == "bstr:cart:update" &&
          bstore.get("bstr:cart:update", 0) > t.minicart.lastUpdate &&
          this.dispatchListeners();
      });
  }
  open() {
    if (document.querySelectorAll("[data-minicart-input]:checked").length)
      return;
    let a = document.querySelectorAll("[data-minicart-input]");
    for (let e of a) {
      let s = e.closestEl(".minicart__label");
      if (s && s.clientHeight > 0 && s.clientWidth > 0) return (e.checked = !0);
    }
  }
  close() {
    let t = document.querySelectorAll("[data-minicart-input]:checked");
    for (let a of t) a.checked = !1;
  }
  async clear() {
    !(await fetch("/cart/clear.js")).ok ||
      this.events.trigger("booster:cart:clear");
  }
  addListener(t, a) {
    let e = t.dataset.cartSettings.split(","),
      s = {};
    for (let i = 0, r = e.length; i < r; ++i) {
      let c = e[i];
      s[c] = t.querySelector(`[data-${c}]`);
    }
    this.listeners.push({ target: t, settings: s });
  }
  minicartHandler(t) {
    for (let a = 0, e = this.listeners.length; a < e; ++a) {
      let s = this.listeners[a],
        i = Object.keys(s.settings);
      for (let r = 0, c = i.length; r < c; ++r) {
        let n = i[r];
        if (
          !!s.settings[n] &&
          !(s.settings[n].dataset.lastUpdate > t) &&
          !(typeof events != "undefined" && events.indexOf(n) == -1)
        ) {
          switch (n) {
            case "count":
              s.settings[n].innerText = this.minicart.data.item_count;
              break;
            case "product-list":
              s.settings[n].innerHTML = this.minicart.data.html;
              break;
            case "total":
              s.settings[n].innerText = this.minicart.data.total;
              break;
          }
          s.settings[n].dataset.lastUpdate = t;
        }
      }
    }
  }
  async dispatchListeners({ change: t = !1 } = {}) {
    let a = this,
      e = Date.now();
    if (e > a.minicart.lastUpdate) {
      let s = await (
          await fetch("/?section_id=api__minicart", {
            headers: {
              Pragma: "no-cache",
              "Cache-Control": "no-cache, no-store, must-revalidate",
              Expires: 0,
            },
          })
        ).text(),
        i = document.createElement("div");
      (i.innerHTML = s),
        (this.minicart = { lastUpdate: e, data: JSON.parse(i.innerText) }),
        (this.minicart.data.items = JSON.parse(this.minicart.data.items)),
        this.events.trigger("booster:cart:update", this.minicart, !0);
    }
    for (
      this.minicartHandler(e),
        t && localStorage.setItem("bstr:cart:update", e),
        this.events.trigger("booster:content:update", { trigger: "minicart" });
      this.awaitingSuccess.length;

    )
      this.success(this.awaitingSuccess.pop());
  }
  quantityHandler(t, a, e = !0) {
    t.preventDefault();
    let s = t.target.parentElement.querySelector("[data-qty-input]");
    if (a) {
      if (!isNaN(parseInt(s.max)) && parseInt(s.value) >= s.max)
        return this.error({
          description: "Seems like there are no more items in stock.",
        });
      s.value++;
    } else {
      if (parseInt(s.value) <= 0 || (!e && parseInt(s.value) == 1)) return !1;
      --s.value;
    }
    return e ? s.onchange({ target: s }) : !0;
  }
  addToQueue(t) {
    this.queue.push(t), !(this.queue.length > 1) && this.checkQueue();
  }
  addToCartIU() {
    let t = document.querySelectorAll("input.inline-upsell__toggle:checked"),
      a = { items: [] };
    for (let e = 0, s = t.length; e < s; ++e) {
      let i = document.getElementById(t[e].dataset.for).value;
      a.items.push({ quantity: 1, id: i });
    }
    this.addToCartJSON(!1, a);
  }
  addToCart(t = !1, a = !1) {
    if (!t && !a) return;
    let e = !1;
    t &&
      ((e = t.currentTarget), t.preventDefault(), t.stopImmediatePropagation()),
      a || (a = e.closest("form")),
      e &&
        ((e.disabled = !0),
        (e.querySelector("[data-button-text]").innerText =
          _bstrLocale.buttons.adding));
    let { prevent: s } = this.events.trigger("booster:cart:b*add", {
      form: a,
      target: e,
    });
    if (s) {
      e &&
        ((e.disabled = !1),
        (e.querySelector("[data-button-text]").innerText =
          e.dataset.originalText));
      return;
    }
    this.addToQueue({ form: a, target: e });
  }
  addToCartJSON(t = !1, a = { items: [] }) {
    let e = !1;
    t && (e = t.currentTarget),
      e &&
        ((e.disabled = !0),
        (e.querySelector("[data-button-text]").innerText =
          _bstrLocale.buttons.adding));
    let { prevent: s } = this.events.trigger("booster:cart:b*add", {
      json: a,
      target: e,
    });
    if (s) {
      e &&
        ((e.disabled = !1),
        (e.querySelector("[data-button-text]").innerText =
          e.dataset.originalText));
      return;
    }
    this.addToQueue({ target: e, json: a });
  }
  async removeFromCart(t = !1, a) {
    let e = t ? t.closest(".minicart__entry") : !1;
    t && (t.disabled = !0), e && (e.style.opacity = "0.5");
    let s = await (
      await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ quantity: 0, id: a }),
      })
    ).json();
    return !isUndefined(s.status) && s.status != "success"
      ? (t && (t.disabled = !1), e && (e.style.opacity = "1"), this.error(s))
      : !0;
  }
  async updateQuantity(t, a, e, s = !1) {
    let { target: i } = t;
    s || ((a = i.dataset.variantId), (e = i.value));
    let r = await (
      await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ quantity: e, id: a }),
      })
    ).json();
    if (!isUndefined(r.status) && r.status != "success") return this.error(r);
  }
  checkQueue() {
    this.queue.length && this.processQueue(this.queue.shift());
  }
  async processQueue(t) {
    if (_lazyCheck == -1) return;
    let { target: a, form: e, json: s } = t,
      i = e
        ? {
            method: "POST",
            body: new URLSearchParams(new FormData(e)),
            headers: { "Content-Type": "multipart/form-data" },
          }
        : {
            method: "POST",
            body: JSON.stringify(s),
            headers: { "Content-Type": "application/json" },
          },
      r = await (await fetch("/cart/add.js", i)).json();
    a &&
      ((a.disabled = !1),
      (a.querySelector("[data-button-text]").innerText =
        a.dataset.originalText)),
      typeof r.status != "undefined" && r.status != "success"
        ? this.error(r)
        : this.awaitingSuccess.push(r),
      this.checkQueue();
  }
  async renderModal(t, a = !1) {
    if (
      this.events.trigger("booster:cart:b*modal", {
        item: t,
        cart: this.minicart,
        will_upsell: a,
      }).prevent
    )
      return;
    let s = document.getElementById("checkout--success"),
      i = s.closest(".modal"),
      r = t.image,
      c = t.product_title,
      n = "",
      p = this.minicart.data.total,
      h = this.minicart.data.item_count,
      g = h + " item" + (h > 1 ? "s" : "");
    t.product_has_only_default_variant || (n = t.variant_title);
    let m = s.querySelector(".add-to-cart__success--single");
    const l = (o) => m.querySelector(o);
    let u = l(".add-to-cart__success--single-img");
    r != null
      ? ((u.src = r), (u.style.display = "block"))
      : (u.style.display = "none"),
      (l(".add-to-cart__success--single-title").innerText = c),
      (l(".add-to-cart__success--single-variation").innerText = n);
    let y = this.cartSuccessInfoTemplate
      .replace("%total%", p)
      .replace("%itemCount%", g);
    l(".add-to-cart__success--single-current").innerHTML = y;
    let b = this.events.trigger("booster:cart:b*upsell", {
      item: t,
      cart: this.minicart,
    });
    if (a && !b.prevent) {
      let o = await this.basync.getUpsell(t.url),
        d = s.querySelector(".add-to-cart__success--upsell");
      if (((d.style.display = "none"), o.trim() != "")) {
        let f = document.getElementById("quickbuy__modal");
        f && (f.style.display = "none"),
          (d.innerHTML = o),
          (d.style.display = "flex"),
          this.events.trigger("booster:cart:upsell", {
            html: d,
            items: !1,
            item: t,
            cart: this.minicart,
          });
      }
    }
    (i.style.display = "block"),
      this.events.trigger("booster:content:update", { trigger: "upsell" });
  }
  success(t) {
    let a = this.cartSuccessConfig,
      e = (t.items && t.items[0]) || t;
    if (
      (this.events.trigger("booster:cart:add", { item: e }), a.action == "cart")
    )
      return (window.location = "/cart");
    if (a.action == "checkout") return (window.location = "/checkout");
    if (a.action == "message")
      return this.events.trigger("booster:notify", {
        type: "success",
        message: "Product added to cart successfully.",
      });
    if (a.action == "minicart") return this.open();
    this.renderModal(e, a.action == "upsell");
  }
  error(t) {
    return (
      console.error(
        `Error trying to add product:
`,
        t
      ),
      this.events.trigger("booster:notify", { type: "error", message: t })
    );
  }
}
class BstrLazy {
  constructor({ events: a, cname: e = "lazyload" }) {
    (this.events = a),
      (this.class = e),
      (this.images = !0),
      "loading" in HTMLImageElement.prototype &&
        _settings.nativeLazyLoad &&
        (this.images = !1),
      this.init();
  }
  init() {
    this.images || this.convertNative(),
      (this.observer = new IntersectionObserver(
        function (e, l) {
          for (let s = 0, c = e.length; s < c; ++s) {
            let r = e[s];
            if (r.isIntersecting) {
              let t = r.target;
              switch (
                (t.classList.remove("lazyload"),
                t.classList.add("lazyloaded"),
                t.tagName)
              ) {
                case "IMG":
                  t.dataset.sizes && (t.sizes = t.dataset.sizes),
                    t.dataset.src && (t.src = t.dataset.src),
                    t.dataset.srcset && (t.srcset = t.dataset.srcset);
                  break;
                case "DIV":
                  if (t.dataset.bgset) {
                    let g = window.innerWidth,
                      o = t.dataset.bgset.split(",");
                    for (let i = 0, h = o.length; i < h; ++i) {
                      let n = o[i].split(" ");
                      if (parseInt(n[1]) >= g || i + 1 == o.length) {
                        t.style.backgroundImage = `url(${n})`;
                        break;
                      }
                    }
                    break;
                  }
                  t.src = t.dataset.src;
                  break;
                case "VIDEO":
                  let d = t.querySelector("source");
                  d.src = d.dataset.src;
                  break;
                default:
                  t.src = t.dataset.src;
                  break;
              }
              l.unobserve(r.target);
            }
          }
        },
        { threshold: 0.05 }
      ));
    let a = this.images
      ? document.querySelectorAll(".lazyload")
      : document.querySelectorAll('.lazyload:not([loading="lazy"])');
    for (let e = 0, l = a.length; e < l; ++e) this.observer.observe(a[e]);
    this.events.on("booster:content:update", () => this.update());
  }
  convertNative() {
    var a = document.querySelectorAll(
      'img[loading="lazy"]:not([data-bstr-initd])'
    );
    for (let e = 0, l = a.length; e < l; ++e) {
      let s = a[e];
      s.dataset.sizes && (s.sizes = s.dataset.sizes),
        s.dataset.src && (s.src = s.dataset.src),
        s.dataset.srcset && (s.srcset = s.dataset.srcset),
        (s.dataset.bstrInitd = "true");
    }
  }
  update() {
    this.images || this.convertNative();
    let a = this.images
      ? document.querySelectorAll(".lazyload")
      : document.querySelectorAll('.lazyload:not([loading="lazy"])');
    for (let e = 0, l = a.length; e < l; ++e) this.observer.observe(a[e]);
  }
}
class BstrAsync {
  constructor({ events: r }) {
    this.events = r;
  }
  async load({ url: r, section: t = !1, selector: n = "body", json: a = !1 }) {
    t && r.searchParams.set("section_id", t);
    let l = await fetch(r.toString());
    if (!l.ok) return {};
    try {
      let s = await l.text(),
        e = new DOMParser().parseFromString(s, "text/html");
      if (!a) return { html: e.querySelector(n).innerHTML, parser: e };
      try {
        return {
          html: e.querySelector(n).innerHTML,
          parser: e,
          json: JSON.parse(e.querySelector(a).innerText),
        };
      } catch (o) {
        return (
          console.debug(o),
          { html: e.querySelector(n).innerHTML, parser: e, json: !1 }
        );
      }
    } catch (s) {
      return console.debug(s), {};
    }
  }
  async getUpsell(r) {
    let { html: t } = await this.load({
      url: new URL(window.location.origin + r),
      section: "api__upsell",
      selector: ".shopify-section",
    });
    return t;
  }
}
class BstrCurrency {
  constructor({ events: o }) {
    (this.moneyFormats = {
      USD: {
        money_format: "${{amount}}",
        money_with_currency_format: "${{amount}} USD",
      },
      EUR: {
        money_format: "&euro;{{amount}}",
        money_with_currency_format: "&euro;{{amount}} EUR",
      },
      GBP: {
        money_format: "&pound;{{amount}}",
        money_with_currency_format: "&pound;{{amount}} GBP",
      },
      CAD: {
        money_format: "${{amount}}",
        money_with_currency_format: "${{amount}} CAD",
      },
      ALL: {
        money_format: "Lek {{amount}}",
        money_with_currency_format: "Lek {{amount}} ALL",
      },
      DZD: {
        money_format: "DA {{amount}}",
        money_with_currency_format: "DA {{amount}} DZD",
      },
      AFN: {
        money_format: "&#65;&#102; {{amount}}",
        money_with_currency_format: "&#65;&#102; {{amount}} AFN",
      },
      AOA: {
        money_format: "Kz{{amount}}",
        money_with_currency_format: "Kz{{amount}} AOA",
      },
      ARS: {
        money_format: "${{amount_with_comma_separator}}",
        money_with_currency_format: "${{amount_with_comma_separator}} ARS",
      },
      AMD: {
        money_format: "{{amount}} AMD",
        money_with_currency_format: "{{amount}} AMD",
      },
      AWG: {
        money_format: "Afl{{amount}}",
        money_with_currency_format: "Afl{{amount}} AWG",
      },
      AUD: {
        money_format: "${{amount}}",
        money_with_currency_format: "${{amount}} AUD",
      },
      BBD: {
        money_format: "${{amount}}",
        money_with_currency_format: "${{amount}} Bds",
      },
      AZN: {
        money_format: "m.{{amount}}",
        money_with_currency_format: "m.{{amount}} AZN",
      },
      BDT: {
        money_format: "Tk {{amount}}",
        money_with_currency_format: "Tk {{amount}} BDT",
      },
      BSD: {
        money_format: "BS${{amount}}",
        money_with_currency_format: "BS${{amount}} BSD",
      },
      BHD: {
        money_format: "{{amount}}0 BD",
        money_with_currency_format: "{{amount}}0 BHD",
      },
      BYN: {
        money_format: "Br {{amount}}",
        money_with_currency_format: "Br {{amount}} BYN",
      },
      BYR: {
        money_format: "Br {{amount}}",
        money_with_currency_format: "Br {{amount}} BYR",
      },
      BZD: {
        money_format: "BZ${{amount}}",
        money_with_currency_format: "BZ${{amount}} BZD",
      },
      BTN: {
        money_format: "Nu {{amount}}",
        money_with_currency_format: "Nu {{amount}} BTN",
      },
      BAM: {
        money_format: "KM {{amount_with_comma_separator}}",
        money_with_currency_format: "KM {{amount_with_comma_separator}} BAM",
      },
      BRL: {
        money_format: "R$ {{amount_with_comma_separator}}",
        money_with_currency_format: "R$ {{amount_with_comma_separator}} BRL",
      },
      BOB: {
        money_format: "Bs{{amount_with_comma_separator}}",
        money_with_currency_format: "Bs{{amount_with_comma_separator}} BOB",
      },
      BMD: {
        money_format: "&#36; {{amount}}",
        money_with_currency_format: "&#36; {{amount}} BMD",
      },
      BIF: {
        money_format: "&#70;&#66;&#117; {{amount}}",
        money_with_currency_format: "&#70;&#66;&#117; {{amount}} BIF",
      },
      BWP: {
        money_format: "P{{amount}}",
        money_with_currency_format: "P{{amount}} BWP",
      },
      BND: {
        money_format: "${{amount}}",
        money_with_currency_format: "${{amount}} BND",
      },
      CVE: {
        money_format: "&#36; {{amount}}",
        money_with_currency_format: "&#36; {{amount}} CVE",
      },
      KMF: {
        money_format: "&#67;&#70; {{amount}}",
        money_with_currency_format: "&#67;&#70; {{amount}} KMF",
      },
      CUC: {
        money_format: "{{amount}}",
        money_with_currency_format: "{{amount}} CUC",
      },
      CUP: {
        money_format: "{{amount}}",
        money_with_currency_format: "{{amount}} CUP",
      },
      CDF: {
        money_format: "&#70;&#67; {{amount}}",
        money_with_currency_format: "&#70;&#67; {{amount}} CDF",
      },
      DJF: {
        money_format: "&#70;&#100;&#106; {{amount}}",
        money_with_currency_format: "&#70;&#100;&#106; {{amount}} DJF",
      },
      ERN: {
        money_format: "{{amount}}",
        money_with_currency_format: "{{amount}} ERN",
      },
      FKP: {
        money_format: "&#163; {{amount}}",
        money_with_currency_format: "&#163; {{amount}} FKP",
      },
      GIP: {
        money_format: "&#163; {{amount}}",
        money_with_currency_format: "&#163; {{amount}} GIP",
      },
      XAU: {
        money_format: "{{amount}}",
        money_with_currency_format: "{{amount}} XAU",
      },
      GGP: {
        money_format: "{{amount}}",
        money_with_currency_format: "{{amount}} GGP",
      },
      GNF: {
        money_format: "&#70;&#71; {{amount}}",
        money_with_currency_format: "&#70;&#71; {{amount}} GNF",
      },
      HTG: {
        money_format: "&#71; {{amount}}",
        money_with_currency_format: "&#71; {{amount}} HTG",
      },
      XDR: {
        money_format: "{{amount}}",
        money_with_currency_format: "{{amount}} XDR",
      },
      IDR: {
        money_format: "{{amount_with_comma_separator}} IDR",
        money_with_currency_format: "Rp {{amount_with_comma_separator}} IDR",
      },
      IQD: {
        money_format: "&#1593;.&#1583; {{amount}}",
        money_with_currency_format: "&#1593;.&#1583; {{amount}} IQD",
      },
      IMP: {
        money_format: "{{amount}}",
        money_with_currency_format: "{{amount}} IMP",
      },
      LAK: {
        money_format: "&#8365; {{amount}}",
        money_with_currency_format: "&#8365; {{amount}} LAK",
      },
      LSL: {
        money_format: "&#76; {{amount}}",
        money_with_currency_format: "&#76; {{amount}} LSL",
      },
      LRD: {
        money_format: "&#36; {{amount}}",
        money_with_currency_format: "&#36; {{amount}} LRD",
      },
      LYD: {
        money_format: "&#1604;.&#1583; {{amount}}",
        money_with_currency_format: "&#1604;.&#1583; {{amount}} LYD",
      },
      MWK: {
        money_format: "&#77;&#75; {{amount}}",
        money_with_currency_format: "&#77;&#75; {{amount}} MWK",
      },
      MRO: {
        money_format: "&#85;&#77; {{amount}}",
        money_with_currency_format: "&#85;&#77; {{amount}} MRO",
      },
      KPW: {
        money_format: "&#8361; {{amount}}",
        money_with_currency_format: "&#8361; {{amount}} KPW",
      },
      OMR: {
        money_format: "{{amount_with_comma_separator}} OMR",
        money_with_currency_format: "{{amount_with_comma_separator}} OMR",
      },
      PAB: {
        money_format: "&#66;&#47;&#46; {{amount}}",
        money_with_currency_format: "&#66;&#47;&#46; {{amount}} PAB",
      },
      SHP: {
        money_format: "&#163; {{amount}}",
        money_with_currency_format: "&#163; {{amount}} SHP",
      },
      SVC: {
        money_format: "&#36; {{amount}}",
        money_with_currency_format: "&#36; {{amount}} SVC",
      },
      SLL: {
        money_format: "&#76;&#101; {{amount}}",
        money_with_currency_format: "&#76;&#101; {{amount}} SLL",
      },
      XAG: {
        money_format: "{{amount}}",
        money_with_currency_format: "{{amount}} XAG",
      },
      SBD: {
        money_format: "&#36; {{amount}}",
        money_with_currency_format: "&#36; {{amount}} SBD",
      },
      SOS: {
        money_format: "&#83; {{amount}}",
        money_with_currency_format: "&#83; {{amount}} SOS",
      },
      SDG: {
        money_format: "&#163; {{amount}}",
        money_with_currency_format: "&#163; {{amount}} SDG",
      },
      SRD: {
        money_format: "&#36; {{amount}}",
        money_with_currency_format: "&#36; {{amount}} SRD",
      },
      SZL: {
        money_format: "&#76; {{amount}}",
        money_with_currency_format: "&#76; {{amount}} SZL",
      },
      TJS: {
        money_format: "&#84;&#74;&#83; {{amount}}",
        money_with_currency_format: "&#84;&#74;&#83; {{amount}} TJS",
      },
      TOP: {
        money_format: "&#84;&#36; {{amount}}",
        money_with_currency_format: "&#84;&#36; {{amount}} TOP",
      },
      TMT: {
        money_format: "&#109; {{amount}}",
        money_with_currency_format: "&#109; {{amount}} TMT",
      },
      UZS: {
        money_format: "&#1083;&#1074; {{amount}}",
        money_with_currency_format: "&#1083;&#1074; {{amount}} UZS",
      },
      YER: {
        money_format: "&#65020; {{amount}}",
        money_with_currency_format: "&#65020; {{amount}} YER",
      },
      BGN: {
        money_format: "{{amount}} \u0110\xBB\u0110\u02DB",
        money_with_currency_format: "{{amount}} \u0110\xBB\u0110\u02DB BGN",
      },
      MMK: {
        money_format: "K{{amount}}",
        money_with_currency_format: "K{{amount}} MMK",
      },
      KHR: {
        money_format: "KHR{{amount}}",
        money_with_currency_format: "KHR{{amount}}",
      },
      KYD: {
        money_format: "${{amount}}",
        money_with_currency_format: "${{amount}} KYD",
      },
      XAF: {
        money_format: "FCFA{{amount}}",
        money_with_currency_format: "FCFA{{amount}} XAF",
      },
      CLP: {
        money_format: "${{amount_no_decimals}}",
        money_with_currency_format: "${{amount_no_decimals}} CLP",
      },
      CNY: {
        money_format: "&#165;{{amount}}",
        money_with_currency_format: "&#165;{{amount}} CNY",
      },
      COP: {
        money_format: "${{amount_with_comma_separator}}",
        money_with_currency_format: "${{amount_with_comma_separator}} COP",
      },
      CRC: {
        money_format: "&#8353; {{amount_with_comma_separator}}",
        money_with_currency_format:
          "&#8353; {{amount_with_comma_separator}} CRC",
      },
      HRK: {
        money_format: "{{amount_with_comma_separator}} kn",
        money_with_currency_format: "{{amount_with_comma_separator}} kn HRK",
      },
      CZK: {
        money_format: "{{amount_with_comma_separator}} K&#269;",
        money_with_currency_format: "{{amount_with_comma_separator}} K&#269;",
      },
      DKK: {
        money_format: "{{amount_with_comma_separator}}",
        money_with_currency_format: "kr.{{amount_with_comma_separator}}",
      },
      DOP: {
        money_format: "RD$ {{amount}}",
        money_with_currency_format: "RD$ {{amount}}",
      },
      XCD: {
        money_format: "${{amount}}",
        money_with_currency_format: "EC${{amount}}",
      },
      EGP: {
        money_format: "LE {{amount}}",
        money_with_currency_format: "LE {{amount}} EGP",
      },
      ETB: {
        money_format: "Br{{amount}}",
        money_with_currency_format: "Br{{amount}} ETB",
      },
      XPF: {
        money_format: "{{amount_no_decimals_with_comma_separator}} XPF",
        money_with_currency_format:
          "{{amount_no_decimals_with_comma_separator}} XPF",
      },
      FJD: {
        money_format: "${{amount}}",
        money_with_currency_format: "FJ${{amount}}",
      },
      GMD: {
        money_format: "D {{amount}}",
        money_with_currency_format: "D {{amount}} GMD",
      },
      GHS: {
        money_format: "GH&#8373;{{amount}}",
        money_with_currency_format: "GH&#8373;{{amount}}",
      },
      GTQ: {
        money_format: "Q{{amount}}",
        money_with_currency_format: "{{amount}} GTQ",
      },
      GYD: {
        money_format: "G${{amount}}",
        money_with_currency_format: "${{amount}} GYD",
      },
      GEL: {
        money_format: "{{amount}} GEL",
        money_with_currency_format: "{{amount}} GEL",
      },
      HNL: {
        money_format: "L {{amount}}",
        money_with_currency_format: "L {{amount}} HNL",
      },
      HKD: {
        money_format: "${{amount}}",
        money_with_currency_format: "HK${{amount}}",
      },
      HUF: {
        money_format: "{{amount_no_decimals_with_comma_separator}}",
        money_with_currency_format:
          "{{amount_no_decimals_with_comma_separator}} Ft",
      },
      ISK: {
        money_format: "{{amount_no_decimals}} kr",
        money_with_currency_format: "{{amount_no_decimals}} kr ISK",
      },
      INR: {
        money_format: "Rs. {{amount}}",
        money_with_currency_format: "Rs. {{amount}}",
      },
      IDR: {
        money_format: "{{amount_with_comma_separator}}",
        money_with_currency_format: "Rp {{amount_with_comma_separator}}",
      },
      ILS: {
        money_format: "{{amount}} NIS",
        money_with_currency_format: "{{amount}} NIS",
      },
      JMD: {
        money_format: "${{amount}}",
        money_with_currency_format: "${{amount}} JMD",
      },
      JPY: {
        money_format: "&#165;{{amount_no_decimals}}",
        money_with_currency_format: "&#165;{{amount_no_decimals}} JPY",
      },
      JEP: {
        money_format: "&pound;{{amount}}",
        money_with_currency_format: "&pound;{{amount}} JEP",
      },
      JOD: {
        money_format: "{{amount}}0 JD",
        money_with_currency_format: "{{amount}}0 JOD",
      },
      KZT: {
        money_format: "{{amount}} KZT",
        money_with_currency_format: "{{amount}} KZT",
      },
      KES: {
        money_format: "KSh{{amount}}",
        money_with_currency_format: "KSh{{amount}}",
      },
      KWD: {
        money_format: "{{amount}}0 KD",
        money_with_currency_format: "{{amount}}0 KWD",
      },
      KGS: {
        money_format: "\u0110\xBB\u0110\u02DB{{amount}}",
        money_with_currency_format: "\u0110\xBB\u0110\u02DB{{amount}}",
      },
      LVL: {
        money_format: "Ls {{amount}}",
        money_with_currency_format: "Ls {{amount}} LVL",
      },
      LBP: {
        money_format: "L&pound;{{amount}}",
        money_with_currency_format: "L&pound;{{amount}} LBP",
      },
      LTL: {
        money_format: "{{amount}} Lt",
        money_with_currency_format: "{{amount}} Lt",
      },
      MGA: {
        money_format: "Ar {{amount}}",
        money_with_currency_format: "Ar {{amount}} MGA",
      },
      MKD: {
        money_format: "\u0110\xB4\u0110\xB5\u0110\u02DD {{amount}}",
        money_with_currency_format:
          "\u0110\xB4\u0110\xB5\u0110\u02DD {{amount}} MKD",
      },
      MOP: {
        money_format: "MOP${{amount}}",
        money_with_currency_format: "MOP${{amount}}",
      },
      MVR: {
        money_format: "Rf{{amount}}",
        money_with_currency_format: "Rf{{amount}} MRf",
      },
      MXN: {
        money_format: "$ {{amount}}",
        money_with_currency_format: "$ {{amount}} MXN",
      },
      MYR: {
        money_format: "RM{{amount}} MYR",
        money_with_currency_format: "RM{{amount}} MYR",
      },
      MUR: {
        money_format: "Rs {{amount}}",
        money_with_currency_format: "Rs {{amount}} MUR",
      },
      MDL: {
        money_format: "{{amount}} MDL",
        money_with_currency_format: "{{amount}} MDL",
      },
      MAD: {
        money_format: "{{amount}} dh",
        money_with_currency_format: "Dh {{amount}} MAD",
      },
      MNT: {
        money_format: "{{amount_no_decimals}} &#8366",
        money_with_currency_format: "{{amount_no_decimals}} MNT",
      },
      MZN: {
        money_format: "{{amount}} Mt",
        money_with_currency_format: "Mt {{amount}} MZN",
      },
      NAD: {
        money_format: "N${{amount}}",
        money_with_currency_format: "N${{amount}} NAD",
      },
      NPR: {
        money_format: "Rs{{amount}}",
        money_with_currency_format: "Rs{{amount}} NPR",
      },
      ANG: {
        money_format: "&fnof;{{amount}}",
        money_with_currency_format: "{{amount}} NA&fnof;",
      },
      NZD: {
        money_format: "${{amount}}",
        money_with_currency_format: "${{amount}} NZD",
      },
      NIO: {
        money_format: "C${{amount}}",
        money_with_currency_format: "C${{amount}} NIO",
      },
      NGN: {
        money_format: "&#8358;{{amount}}",
        money_with_currency_format: "&#8358;{{amount}} NGN",
      },
      NOK: {
        money_format: "kr {{amount_with_comma_separator}}",
        money_with_currency_format: "kr {{amount_with_comma_separator}} NOK",
      },
      OMR: {
        money_format: "{{amount_with_comma_separator}} OMR",
        money_with_currency_format: "{{amount_with_comma_separator}} OMR",
      },
      PKR: {
        money_format: "Rs.{{amount}}",
        money_with_currency_format: "Rs.{{amount}} PKR",
      },
      PGK: {
        money_format: "K {{amount}}",
        money_with_currency_format: "K {{amount}} PGK",
      },
      PYG: {
        money_format: "Gs. {{amount_no_decimals_with_comma_separator}}",
        money_with_currency_format:
          "Gs. {{amount_no_decimals_with_comma_separator}} PYG",
      },
      PEN: {
        money_format: "S/. {{amount}}",
        money_with_currency_format: "S/. {{amount}} PEN",
      },
      PHP: {
        money_format: "&#8369;{{amount}}",
        money_with_currency_format: "&#8369;{{amount}} PHP",
      },
      PLN: {
        money_format: "{{amount_with_comma_separator}} zl",
        money_with_currency_format: "{{amount_with_comma_separator}} zl PLN",
      },
      QAR: {
        money_format: "QAR {{amount_with_comma_separator}}",
        money_with_currency_format: "QAR {{amount_with_comma_separator}}",
      },
      RON: {
        money_format: "{{amount_with_comma_separator}} lei",
        money_with_currency_format: "{{amount_with_comma_separator}} lei RON",
      },
      RUB: {
        money_format: "&#1088;&#1091;&#1073;{{amount_with_comma_separator}}",
        money_with_currency_format:
          "&#1088;&#1091;&#1073;{{amount_with_comma_separator}} RUB",
      },
      RWF: {
        money_format: "{{amount_no_decimals}} RF",
        money_with_currency_format: "{{amount_no_decimals}} RWF",
      },
      WST: {
        money_format: "WS$ {{amount}}",
        money_with_currency_format: "WS$ {{amount}} WST",
      },
      SAR: {
        money_format: "{{amount}} SR",
        money_with_currency_format: "{{amount}} SAR",
      },
      STD: {
        money_format: "Db {{amount}}",
        money_with_currency_format: "Db {{amount}} STD",
      },
      RSD: {
        money_format: "{{amount}} RSD",
        money_with_currency_format: "{{amount}} RSD",
      },
      SCR: {
        money_format: "Rs {{amount}}",
        money_with_currency_format: "Rs {{amount}} SCR",
      },
      SGD: {
        money_format: "${{amount}}",
        money_with_currency_format: "${{amount}} SGD",
      },
      SYP: {
        money_format: "S&pound;{{amount}}",
        money_with_currency_format: "S&pound;{{amount}} SYP",
      },
      ZAR: {
        money_format: "R {{amount}}",
        money_with_currency_format: "R {{amount}} ZAR",
      },
      KRW: {
        money_format: "&#8361;{{amount_no_decimals}}",
        money_with_currency_format: "&#8361;{{amount_no_decimals}} KRW",
      },
      LKR: {
        money_format: "Rs {{amount}}",
        money_with_currency_format: "Rs {{amount}} LKR",
      },
      SEK: {
        money_format: "{{amount_no_decimals}} kr",
        money_with_currency_format: "{{amount_no_decimals}} kr SEK",
      },
      CHF: {
        money_format: "SFr. {{amount}}",
        money_with_currency_format: "SFr. {{amount}} CHF",
      },
      TWD: {
        money_format: "${{amount}}",
        money_with_currency_format: "${{amount}} TWD",
      },
      THB: {
        money_format: "{{amount}} &#xe3f;",
        money_with_currency_format: "{{amount}} &#xe3f; THB",
      },
      TZS: {
        money_format: "{{amount}} TZS",
        money_with_currency_format: "{{amount}} TZS",
      },
      TTD: {
        money_format: "${{amount}}",
        money_with_currency_format: "${{amount}} TTD",
      },
      TND: {
        money_format: "{{amount}}",
        money_with_currency_format: "{{amount}} DT",
      },
      TRY: {
        money_format: "{{amount}}TL",
        money_with_currency_format: "{{amount}}TL",
      },
      UGX: {
        money_format: "Ush {{amount_no_decimals}}",
        money_with_currency_format: "Ush {{amount_no_decimals}} UGX",
      },
      UAH: {
        money_format: "\xE2\u201A\xB4{{amount}}",
        money_with_currency_format: "\xE2\u201A\xB4{{amount}} UAH",
      },
      AED: {
        money_format: "Dhs. {{amount}}",
        money_with_currency_format: "Dhs. {{amount}} AED",
      },
      UYU: {
        money_format: "${{amount_with_comma_separator}}",
        money_with_currency_format: "${{amount_with_comma_separator}} UYU",
      },
      VUV: {
        money_format: "${{amount}}",
        money_with_currency_format: "${{amount}}VT",
      },
      VEF: {
        money_format: "Bs. {{amount_with_comma_separator}}",
        money_with_currency_format: "Bs. {{amount_with_comma_separator}} VEF",
      },
      VND: {
        money_format: "{{amount_no_decimals_with_comma_separator}}&#8363;",
        money_with_currency_format:
          "{{amount_no_decimals_with_comma_separator}} VND",
      },
      XBT: {
        money_format: "{{amount_no_decimals}} BTC",
        money_with_currency_format: "{{amount_no_decimals}} BTC",
      },
      XOF: {
        money_format: "CFA{{amount}}",
        money_with_currency_format: "CFA{{amount}} XOF",
      },
      ZMW: {
        money_format: "K{{amount_no_decimals_with_comma_separator}}",
        money_with_currency_format:
          "ZMW{{amount_no_decimals_with_comma_separator}}",
      },
    }),
      (this.currentCurrency = bstore.get("currentCurrency")),
      (this.format = _settings.currencyFormat || "money_with_currency_format"),
      (this.events = o),
      this.currentCurrency &&
        Shopify.currency.active !== this.currentCurrency &&
        this.convertAll({}),
      this.events.on("booster:content:update", (m = {}) => this.convertAll(m)),
      this.events.on("booster:price:update", this.priceUpdate.bind(this));
  }
  formatMoney(o, m) {
    typeof o == "string" && (o = o.replace(".", ""));
    var n = "",
      e = /\{\{\s*(\w+)\s*\}\}/,
      r = m || "${{amount}}";
    function t(a, u) {
      return a === void 0 ? u : a;
    }
    function _(a, u, y, c) {
      if (
        ((u = t(u, 2)), (y = t(y, ",")), (c = t(c, ".")), isNaN(a) || a == null)
      )
        return 0;
      var f = (a = (a / 100).toFixed(u)).split(".");
      return (
        f[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + y) +
        (f[1] ? c + f[1] : "")
      );
    }
    switch (r.match(e)[1]) {
      case "amount":
        n = _(o, 2);
        break;
      case "amount_no_decimals":
        n = _(o, 0);
        break;
      case "amount_with_comma_separator":
        n = _(o, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        n = _(o, 0, ".", ",");
    }
    return r.replace(e, n);
  }
  priceUpdate({ elements: o }) {
    let m = Shopify.currency.active,
      n = bstore.get("currentCurrency"),
      e = this.getFormat(n),
      r = this.getFormat(m);
    if (m != n)
      for (let t of o)
        this.elemConvert({
          element: t,
          oldCurrency: m,
          newCurrency: n,
          oldFormat: r,
          newFormat: e,
        });
  }
  elemConvert({
    element: o,
    oldCurrency: m = !1,
    newCurrency: n = !1,
    newFormat: e = !1,
    oldFormat: r = !1,
  }) {
    let t = o.innerText;
    if (!t || t.trim() == "") return;
    let _ = m || Shopify.currency.active;
    if (!_) return;
    let a = n || bstore.get("currentCurrency");
    if (!a) return;
    let u = e || this.getFormat(a),
      y = r || this.getFormat(_),
      c;
    (c =
      y.indexOf("amount_no_decimals") !== -1
        ? Currency.convert(100 * parseInt(t.replace(/[^0-9]/g, ""), 10), _, a)
        : _ === "JOD" || _ == "KWD" || _ == "BHD"
        ? Currency.convert(parseInt(t.replace(/[^0-9]/g, ""), 10) / 10, _, a)
        : Currency.convert(parseInt(t.replace(/[^0-9]/g, ""), 10), _, a)),
      (o.innerHTML = this.formatMoney(c, u)),
      (o.dataset.currency = a);
  }
  convert({ amount: o = !1, oldc: m = !1, newc: n = !1 }) {
    if (
      !o ||
      ((m = m || Shopify.currency.active), !m) ||
      ((n = n || bstore.get("currentCurrency")), !n)
    )
      return o;
    let e = this.getFormat(n),
      r = this.getFormat(m),
      t;
    return (
      (t =
        r.indexOf("amount_no_decimals") !== -1
          ? Currency.convert(100 * parseInt(o.replace(/[^0-9]/g, ""), 10), m, n)
          : m === "JOD" || m == "KWD" || m == "BHD"
          ? Currency.convert(parseInt(o.replace(/[^0-9]/g, ""), 10) / 10, m, n)
          : Currency.convert(parseInt(o.replace(/[^0-9]/g, ""), 10), m, n)),
      this.formatMoney(t, e)
    );
  }
  convertAll({
    oldCurrency: o = !1,
    newCurrency: m = !1,
    selector: n = ".jsPrice",
    format: e = this.format,
  }) {
    let r = o || Shopify.currency.active;
    if (!r) return;
    let t = m || bstore.get("currentCurrency");
    if (!t || t == r) return;
    let _ = this.moneyFormats[r][e] || "{{amount}}",
      a = this.moneyFormats[t][e] || "{{amount}}",
      u = document.querySelectorAll(n);
    for (let y = 0, c = u.length; y < c; ++y) {
      let f,
        h = u[y];
      if (h.dataset.currency == t) continue;
      let i = h.innerText;
      !i ||
        i.trim() == "" ||
        ((f =
          _.indexOf("amount_no_decimals") !== -1
            ? Currency.convert(
                100 * parseInt(i.replace(/[^0-9]/g, ""), 10),
                r,
                t
              )
            : r === "JOD" || r == "KWD" || r == "BHD"
            ? Currency.convert(
                parseInt(i.replace(/[^0-9]/g, ""), 10) / 10,
                r,
                t
              )
            : Currency.convert(parseInt(i.replace(/[^0-9]/g, ""), 10), r, t)),
        (h.innerHTML = this.formatMoney(f, a)),
        (h.dataset.currency = t));
    }
    bstore.set("currentCurrency", t), (this.currentCurrency = t);
  }
  getFormat(o = !1, m = !1) {
    return (
      (m = m || _settings.currencyFormat || "money_with_currency_format"),
      (o = o || Shopify.currency.active),
      this.moneyFormats[o][m]
    );
  }
}
class BstrIU {
  constructor({ cfx: e, events: a, swatches: r }) {
    (this.cfx = e),
      (this.swatches = r),
      (this.events = a),
      this.events.on("booster:variant:select", this.syncInputs.bind(this));
  }
  syncInputs(e) {
    if (!e.selectedVariant.available) return;
    let a = e.product.id,
      r = e.selectedVariant.id;
    document.querySelectorAll(`[data-upsell-id="${a}"]`).forEach((i) => {
      i.tagName == "SELECT" && i.value != r && (i.value = r);
    }),
      this.toggleVariantIU();
  }
  toggleVariantIU(e = !1) {
    let a = document.getElementById("inline-upsell__total");
    if (!a) return;
    let r = document.getElementById("inline-upsell__discount");
    if (e && e.tagName == "SELECT") {
      let s = e.dataset.upsellId,
        p = e.value;
      this.swatches.setProductVariant(s, p);
    }
    let i = document.querySelectorAll("input.inline-upsell__toggle:checked"),
      o = 0,
      d = 0,
      n = [],
      c = this.cfx.getFormat(Shopify.currency.active);
    for (let s = 0, p = i.length; s < p; ++s) {
      let t = document.getElementById(i[s].dataset.for),
        u =
          t.tagName == "INPUT"
            ? parseInt(t.dataset.price)
            : parseInt(t.options[t.selectedIndex].dataset.price),
        f =
          t.tagName == "INPUT"
            ? parseInt(t.dataset.comparePrice)
            : parseInt(t.options[t.selectedIndex].dataset.comparePrice),
        h = t.closestEl(".card--default"),
        m = h.querySelector("[data-iu-price]"),
        l = h.querySelector("[data-iu-price-sale]");
      (m.innerHTML = this.cfx.formatMoney(u, c)),
        n.push(m),
        f > u
          ? (l.parentElement.classList.add("card__price--sale"),
            (l.innerHTML = this.cfx.formatMoney(f, c)),
            n.push(l))
          : (l.parentElement.classList.remove("card__price--sale"),
            (l.innerHTML = "")),
        (o += u),
        (d += f);
    }
    (a.innerHTML = this.cfx.formatMoney(o, c)),
      (r.innerHTML = d > o ? this.cfx.formatMoney(d, c) : ""),
      n.push(a, r),
      this.events.trigger("booster:price:update", {
        currency: Shopify.currency.active,
        elements: n,
      });
  }
}
class BstrSlider {
  constructor({ events: e, selector: t, breakpoints: r } = {}) {
    (this._selector = t || "[data-bstr-slider]"),
      (this._idSelector = this._selector
        .replace(/(\[data-|\])/g, "")
        .replace(/-(\w)/g, (s) => s[1].toUpperCase())),
      (this._breakpoints = r || { sm: 768, md: 1024 }),
      (this._sliders = {}),
      (this._currentIndex = 0),
      (this._resize = !1),
      this.init(),
      e.on("booster:content:update", () => this.init());
  }
  _isVisible(e, t, r) {
    return r
      ? t.top - e.top <= 0 && t.bottom - e.bottom >= 0
      : t.left - e.left <= 0 && t.right - e.right >= 0;
  }
  async _parentMoveCallback(e) {
    let t = parseInt(e.dataset.bstrSliderCurrent);
    const r = e.dataset.bstrSliderOrientation.toLowerCase() == "vertical";
    if (!e.querySelector("[data-bstr-slide]")) return;
    let s = Math.round(
      r
        ? e.scrollTop / e.querySelector("[data-bstr-slide]").offsetHeight
        : e.scrollLeft / e.querySelector("[data-bstr-slide]").offsetWidth
    );
    e.dataset.bstrSliderCurrent = s;
    let i = t - s > 0 ? "+" : "-",
      l = e.querySelectorAll("[data-bstr-slide]"),
      o = [],
      a = [];
    const c = e.closest("[data-bstr-slide-holder]").getBoundingClientRect();
    for (let n = 0; n < l.length; ++n) {
      let d = l[n];
      this._isVisible(c, d.getBoundingClientRect(), r)
        ? ((d.dataset.bstrSlide = "active"), a.push({ index: n, target: d }))
        : d.dataset.bstrSlide == "active" &&
          ((d.dataset.bstrSlide = ""), o.push({ index: n, target: d }));
    }
    this._moveCallback &&
      this._moveCallback({ direction: i, slider: e, current: a, previous: o });
  }
  init(e = !1) {
    let t = document.querySelectorAll(
      `${e || this._selector}:not([data-bstr-initd])`
    );
    for (let r of t) {
      let s = r.querySelector("[data-bstr-slide-holder]"),
        i;
      r.dataset[this._idSelector]
        ? (i = r.dataset[this._idSelector])
        : ((i = ++this._currentIndex), (r.dataset[this._idSelector] = i)),
        r.setAttribute("data-bstr-initd", "true"),
        (s.dataset.bstrSliderId = i);
      let l = s.dataset.bstrSlideHolder.split("|");
      if (l.length == 3)
        this._sliders[i] = {
          lg: parseInt(l[0]),
          md: parseInt(l[1]),
          sm: parseInt(l[2]),
        };
      else {
        let a = parseInt(l[0]);
        this._sliders[i] = isNaN(a)
          ? { lg: 1, md: 1, sm: 1 }
          : { lg: a, md: a, sm: a };
      }
      let o = [
        ...r.querySelectorAll("[data-bstr-slider-button]"),
        ...document.querySelectorAll(
          `[data-bstr-slider-button][data-bstr-for-slider="${i}"]`
        ),
      ];
      for (let a of o)
        a.addEventListener("click", (c) => {
          c.preventDefault(),
            c.stopImmediatePropagation(),
            this._move({
              slider: s,
              direction: a.dataset.bstrSliderButton || "+",
            });
        });
      this._parentMoveCallback(s),
        s.addEventListener(
          "scroll",
          debounce(() => this._parentMoveCallback(s), 100),
          { passive: !0 }
        );
    }
    this._resize ||
      (this._resizeHandler(),
      window.addEventListener(
        "resize",
        debounce(this._resizeHandler.bind(this), 250),
        { passive: !0 }
      ),
      (this._resize = !0));
  }
  _resizeHandler() {
    window.innerWidth < this._breakpoints.sm
      ? (this.viewport = "sm")
      : window.innerWidth < this._breakpoints.md
      ? (this.viewport = "md")
      : (this.viewport = "lg"),
      (this.rawViewport = window.innerWidth);
  }
  _moveTo({ index: e = 0, slider: t }) {
    console.log("test");
    let r = parseInt(t.dataset.bstrSliderCurrent),
      s = t.dataset.bstrSliderOrientation.toLowerCase() == "vertical",
      i = t.querySelectorAll("[data-bstr-slide]");
    !i.length ||
      ((r = Math.max(Math.min(e, i.length - 1), 0)),
      s
        ? t.scrollTo(0, i[r].offsetTop - t.offsetTop)
        : t.scrollTo(
            i[r].offsetLeft -
              t.offsetLeft -
              parseInt(window.getComputedStyle(t).paddingLeft),
            0
          ));
  }
  _move({ direction: e, slider: t }) {
    let r = this._sliders[t.dataset.bstrSliderId][this.viewport],
      s = parseInt(t.dataset.bstrSliderCurrent),
      i = s,
      l = t.dataset.bstrSliderOrientation.toLowerCase() == "vertical",
      o = t.querySelectorAll("[data-bstr-slide]");

    if(!o[s]) return
    if (!o.length) return;
    let a = Math.round(
      l
        ? 1 / (o[0].offsetHeight / t.offsetHeight)
        : 1 /
            (o[0].offsetWidth /
              (t.offsetWidth -
                parseInt(window.getComputedStyle(t).paddingLeft)))
    );
    (s = e === "+" ? Math.min(s + r, o.length - a) : Math.max(s - r, 0)),
      t.dataset.bstrSlideLoop &&
        s === i &&
        (e === "-" ? (s = o.length - a) : (s = 0)),
      l
        ? t.scrollTo(0, o[s].offsetTop - t.offsetTop)
        : t.scrollTo(
            o[s].offsetLeft -
              t.offsetLeft -
              parseInt(window.getComputedStyle(t).paddingLeft),
            0
          );
  }
}
class ProductSlider extends BstrSlider {
  constructor(e) {
    super(e);
    this.initThumbs(), e.events.on("booster:content:update", this.initThumbs);
  }
  initThumbs() {
    let e = document.querySelectorAll(
      "[data-bstr-slider-thumb]:not([data-bstr-initd])"
    );
    for (let t of e) {
      let r = t.dataset.bstrSliderFor,
        s = r
          ? document.querySelector(
              `[data-bstr-ppslider="${r}"] [data-bstr-slide-holder]`
            )
          : t.closest("[data-bstr-ppslider]"),
        i = parseInt(t.dataset.bstrSliderThumb);

      console.log(t);
      t.addEventListener("click", () => super._moveTo({ slider: s, index: i }));

      t.getAttribute("data-bstr-slider-thumb-hover") != null &&
        t.addEventListener("mouseover", () =>
          this._moveTo({ slider: s, index: i })
        );
    }
  }
  _moveCallback({ slider: e, current: t }) {
    if (!t.length) return;
    let r = e.dataset.bstrSliderId;
    for (let s of document.querySelectorAll(
      `.bstrSlider__thumb--active[data-bstr-slider-for="${r}"]`
    ))
      s.classList.remove("bstrSlider__thumb--active");
    if (window.innerWidth < 790) {
      let s = 0;
      for (let i of t) {
        let l = i.target.children[0];
        !l || (l.clientHeight > s && (s = l.clientHeight));
      }
      s && (e.closest("[data-bstr-ppslider]").style.maxHeight = `${s}px`);
    } else e.closest("[data-bstr-ppslider]").style.maxHeight = null;
    document
      .querySelector(
        `[data-bstr-slider-thumb="${t[0].index}"][data-bstr-slider-for="${r}"]`
      )
      .classList.add("bstrSlider__thumb--active");
  }
}
class BstrSectionSlider extends BstrSlider {
  constructor(e) {
    super(e);
  }
  _moveCallback(e) {
    for (let { target: t } of e.previous) {
      let r = t.dataset.type == "bannerSlider" ? t.querySelector("div") : t;
      r.dataset.type == "video" && r.querySelector("video").pause(),
        r.classList.remove("slide__animation");
    }
    for (let { target: t } of e.current) {
      let r = t.dataset.type == "bannerSlider" ? t.querySelector("div") : t;
      r.dataset.type == "video" && r.querySelector("video").play(),
        r.classList.add("slide__animation");
    }
    e.slider.dataset.sliderHolder == "adaptive" &&
      (e.slider.style.height = `${e.current[0].target.offsetHeight}px`);
  }
}
class BstrSwatchesTheme {
  constructor({ swatches: t, events: i, slider: c, cfx: l }) {
    (this.sw = t),
      (this.cfx = l),
      (this.slider = c),
      (this.events = i),
      this.initEvents();
  }
  initEvents() {
    this.events.on("booster:variant:select", this.selectSwatch.bind(this)),
      this.events.on(
        "booster:variant:deselect",
        this.deselectSwatch.bind(this)
      ),
      _settings.variantShowImage &&
        this.events.on("booster:swatch:update", this.scrollToImage.bind(this)),
      this.events.on("booster:swatch:render", this.renderSwatches.bind(this));
  }
  renderSwatches({ pid: t, options: i, aOptions: c }) {
    for (let e = 0; e < c.length; ++e) {
      let r = document.querySelectorAll(`[data-swatch-index="${t}-${e}"]`);
      for (let a of r)
        a.tagName == "OPTION"
          ? c[e].has(a.value)
            ? a.removeAttribute("disabled")
            : a.setAttribute("disabled", "true")
          : a.tagName !== "SELECT" &&
            (c[e].has(a.dataset.swatchOption)
              ? a.classList.remove("swatch--disabled")
              : a.classList.add("swatch--disabled"));
    }
    for (let e of document.querySelectorAll(
      `.swatch--active[data-swatch-index^="${t}"]`
    ))
      e.classList.remove("swatch--active");
    for (let e = 0; e < i.length; ++e)
      i[e] === !1
        ? (document
            .querySelectorAll(`span[data-swatch-selected-name="${t}-${e}"]`)
            .forEach((r) => (r.innerText = "")),
          document
            .querySelectorAll(`select[data-swatch-index="${t}-${e}"]`)
            .forEach((r) => (r.value = "bstrSelectNill")))
        : document
            .querySelectorAll(`span[data-swatch-selected-name="${t}-${e}"]`)
            .forEach((r) => (r.innerText = " - " + i[e]));
    let l = [];
    for (let e = 0; e < i.length; ++e)
      i[e] !== !1 &&
        (l.push(
          ...document.querySelectorAll(
            `[data-swatch-option="${CSS.escape(
              i[e]
            )}"][data-swatch-index="${t}-${e}"]`
          )
        ),
        l.push(
          ...document.querySelectorAll(
            `option[value="${CSS.escape(i[e])}"][data-swatch-index="${t}-${e}"]`
          )
        ));
    for (let e of l)
      e.tagName == "OPTION"
        ? (e.closest("select").value = e.value)
        : e.classList.add("swatch--active");
  }
  scrollToImage(t) {
    let i = "";
    const c = t.currentOptions.length;
    let l = new Array(c * 2).fill("#");
    (l[0] = "|"), (l[c * 2 - 1] = "|");
    let e = new Array(c).fill("*");
    if (
      ((e[0] = "^"), (e[c - 1] = "$"), t.currentOptions.some((r) => r !== !1))
    ) {
      if (t.currentOptions.includes(!1))
        for (let a = 0; a < c * 2; a += 2)
          t.currentOptions[a / 2] !== !1 &&
            (i += `[data-variants${e[a / 2]}="${l[a]}${CSS.escape(
              t.currentOptions[a / 2]
            )}${l[a + 1]}"]`);
      else {
        let a = "";
        for (let o = 0; o < c * 2; o += 2)
          a += `${l[o]}${CSS.escape(t.currentOptions[o / 2])}${l[o + 1]}`;
        i = `[data-variants*="${a}"]`.replace(/##/g, "#");
      }
      let r = document.querySelector(i);
      if (r) {
        let a = r.closest("[data-bstr-slide-holder]"),
          o = Array.from(a.children).indexOf(r);
        this.slider._moveTo({ index: o, slider: a });
      }
    }
  }
  selectSwatch(t) {
    let i = t.product.id,
      c = t.selectedVariant.price,
      l = t.selectedVariant,
      e = document.querySelectorAll(`[data-product-price="${i}"]`),
      r = l.sale_raw;
    e.forEach((s) => {
      (s.innerText = c),
        r
          ? s.classList.add("product__price--sale")
          : s.classList.remove("product__price--sale");
    }),
      document.querySelectorAll(`[data-tag-product="${i}"]`).forEach((s) => {
        let n = r ? s.dataset.tagType : !1;
        switch (n) {
          case "percent": {
            s.innerText =
              Math.floor(((l.price_raw - l.sale_raw) / l.sale_raw) * 100) +
              "% " +
              _bstrLocale.tags.off;
            break;
          }
          case "amount": {
            s.innerText = this.cfx.formatMoney(
              l.sale_raw - l.price_raw,
              this.cfx.getFormat()
            );
            break;
          }
          case "text": {
            s.innerText = _bstrLocale.tags.sale.toUpperCase();
            break;
          }
          default: {
            s.classList.add("hide");
            break;
          }
        }
        n && s.classList.remove("hide");
      }),
      document
        .querySelectorAll(`[data-product-price-sale="${i}"]`)
        .forEach((s) => {
          if (!r) return s.classList.add("hide");
          (s.innerText = l.sale), s.classList.remove("hide");
        });
    let a = document.querySelectorAll(
      `input[data-bstr-variant-input="${t.product.id}"]`
    );
    for (let s of a) s.setAttribute("value", t.selectedVariant.id);
    let o = document.querySelectorAll(`[data-buy-button="${t.product.id}"]`);
    for (let s of o)
      l.available
        ? ((s.querySelector("[data-button-text]").innerText =
            s.dataset.originalText),
          s.removeAttribute("disabled"))
        : ((s.querySelector("[data-button-text]").innerText =
            _bstrLocale.buttons.sold_out),
          s.setAttribute("disabled", "true"));
    let u = document.querySelectorAll(
      `[data-dynamic-button="${t.product.id}"]`
    );
    for (let s of u) {
      let n = s.querySelector("button");
      !n ||
        (l.available
          ? n.removeAttribute("disabled")
          : n.setAttribute("disabled", "true"));
    }
    let d = new URL(document.URL);
    d.searchParams.set("variant", t.selectedVariant.id),
      history.replaceState({}, "", d),
      this.events.trigger("booster:price:update", { elements: e });
  }
  deselectSwatch(t) {
    let i = document.querySelectorAll(
      `input[data-bstr-variant-input="${t.product.id}"]`
    );
    for (let r of i) r.setAttribute("value", -1);
    let c = document.querySelectorAll(`[data-buy-button="${t.product.id}"]`);
    for (let r of c)
      r.setAttribute("disabled", "true"),
        (r.querySelector("[data-button-text]").innerText =
          _bstrLocale.buttons.select);
    let l = document.querySelectorAll(
      `[data-dynamic-button="${t.product.id}"]`
    );
    for (let r of l) {
      let a = r.querySelector("button");
      !a || a.setAttribute("disabled", "true");
    }
    let e = new URL(document.URL);
    e.searchParams.delete("variant"), history.replaceState({}, "", e);
  }
}
class BstrSwatches {
  constructor({ events: t, slider: r, cfx: e }) {
    (this.events = t),
      (this.current = {}),
      (this.variants = {}),
      (this.THEME_UTILS = new BstrSwatchesTheme({
        swatches: this,
        events: t,
        slider: r,
        cfx: e,
      })),
      this.initListeners(),
      this.events.on("booster:content:update", () => {
        this.initListeners();
        for (let s of Object.keys(this.current)) this.filterSwatches(s);
      });
  }
  initListeners() {
    const t = this;
    let r = document.querySelectorAll(
      "[data-swatch-index]:not([data-booster-initd])"
    );
    for (let e of r)
      e.tagName != "OPTION" &&
        (e.tagName === "SELECT"
          ? e.addEventListener("change", (s) => {
              let a = s.currentTarget,
                n = a.value,
                i = a.dataset.swatchIndex.trim().split("-"),
                o;
              n === "bstrSelectNill" ? (o = !1) : (o = n),
                t.setOption(i[0], parseInt(i[1]), o);
            })
          : e.addEventListener("click", (s) => {
              let a = s.currentTarget;
              if (
                (_settings.swatchLogic != "amazon" &&
                  a.classList.contains("swatch--disabled")) ||
                (_settings.disableSOSwatch && a.dataset.swatchSoldout)
              )
                return;
              let n = a.dataset.swatchIndex.trim().split("-"),
                i;
              a.classList.contains("swatch--active")
                ? (i = !1)
                : (i = e.dataset.swatchOption),
                t.setOption(n[0], parseInt(n[1]), i);
            }),
        (e.dataset.boosterInitd = "true"));
    if (_settings.preselectSwatch != "false") {
      let e = document.querySelectorAll(
        "noscript[data-bstr-preselect]:not(data-bstr-initd)"
      );
      if (_settings.preselectSwatch == "firstOptionIndex")
        for (let s of e)
          (s.dataset.bstrInitd = "true"),
            !Object.keys(this.current).includes(s.dataset.bstrSwatch) &&
              this.setOption(
                s.dataset.bstrSwatch,
                0,
                this.getVariant(s.dataset.bstrSwatch, s.dataset.bstrPreselect)
                  .options[0]
              );
      else
        for (let s of e)
          (s.dataset.bstrInitd = "true"),
            !Object.keys(this.current).includes(s.dataset.bstrSwatch) &&
              this.setProductVariant(
                s.dataset.bstrSwatch,
                s.dataset.bstrPreselect
              );
    }
  }
  getVariants(t) {
    return (
      this.variants[t] ||
        (this.variants[t] = JSON.parse(
          document.querySelector(`noscript[data-bstr-swatch="${t}"]`).innerText
        )),
      this.variants[t]
    );
  }
  getVariant(t, r) {
    return this.getVariants(t)[r];
  }
  findVariant(t) {
    const r = this.current[t],
      e = this.getVariants(t);
    for (let [s, a] of Object.entries(e)) {
      let n = !0;
      for (let i = 0; i < r.length; ++i)
        if (r[i] !== !1 && a.options[i] !== r[i]) {
          n = !1;
          break;
        }
      if (n) return s;
    }
    return !1;
  }
  dropCombination(t, r) {
    const e = this.getVariants(t),
      s = Object.values(e),
      a = [...this.current[t]];
    let n = this.genArray(() => [], 0, a.length),
      i;
    for (let o = 0; o < a.length; ++o)
      if (!(a[o] === !1 || o === r)) {
        i = o;
        break;
      }
    for (let { options: o } of s)
      if (o[r] == a[r]) for (let c = 0; c < o.length; ++c) n[c].push(o[c]);
    for (let o = 0; o < n.length; ++o)
      o !== r &&
        (n[o].includes(this.current[t][o]) || (this.current[t][o] = !1));
    if (
      JSON.stringify(a) === JSON.stringify(this.current[t]) &&
      ((this.current[t][i] = !1), !this.findVariant(t))
    )
      return this.dropCombination(t, r);
  }
  validateOptions(t, r, e) {
    let s = this.findVariant(t),
      a = !1;
    typeof s != "boolean" && (a = s), (this.current[t] = r);
    let n = this.findVariant(t);
    n === !1
      ? (_settings.swatchLogic === "amazon" && this.dropCombination(t, e),
        this.events.trigger("booster:swatch:update", {
          selectedVariant: !1,
          currentOptions: this.current[t],
          product: { id: t, variants: this.getVariants(t) },
        }),
        a !== !1 &&
          this.events.trigger("booster:variant:deselect", {
            oldVariant: a,
            currentOptions: this.current[t],
            product: { id: t, variants: this.getVariants(t) },
          }))
      : this.current[t].includes(!1)
      ? (this.events.trigger("booster:swatch:update", {
          selectedVariant: !1,
          currentOptions: this.current[t],
          product: { id: t, variants: this.getVariants(t) },
        }),
        a !== !1 &&
          this.events.trigger("booster:variant:deselect", {
            oldVariant: a,
            currentOptions: this.current[t],
            product: { id: t, variants: this.getVariants(t) },
          }))
      : (this.events.trigger("booster:swatch:update", {
          selectedVariant: this.getVariant(t, n),
          currentOptions: this.current[t],
          product: { id: t, variants: this.getVariants(t) },
        }),
        this.events.trigger("booster:variant:select", {
          selectedVariant: this.getVariant(t, n),
          currentOptions: this.current[t],
          product: { id: t, variants: this.getVariants(t) },
        })),
      this.filterSwatches(t);
  }
  setOption(t, r, e) {
    this.current[t] ||
      (this.current[t] = new Array(
        Object.values(this.getVariants(t))[0].options.length
      ).fill(!1));
    let s = [...this.current[t]];
    (s[r] = e), this.validateOptions(t, s, r);
  }
  setOptions(t, r) {
    this.current[t] ||
      (this.current[t] = new Array(
        Object.values(this.getVariants(t))[0].options.length
      ).fill(!1)),
      this.validateOptions(t, [...r], 0);
  }
  setProductVariant(t, r) {
    const e = this.getVariant(t, r);
    this.setOptions(t, e.options);
  }
  genArray(t, r, e) {
    let s = [];
    for (let a = r; a < e; ++a) s[a] = t.call();
    return s;
  }
  matchesOptions(t, r) {
    for (let e = 0; e < r.length; ++e)
      if (t[e] !== !1 && t[e] != r[e]) return !1;
    return !0;
  }
  filterSwatches(t) {
    const r = this.getVariants(t),
      e = this.current[t];
    let s = e.length,
      a = this.genArray(() => new Set(), 0, s);
    for (let n of Object.values(r))
      for (let i = 0; i < s; ++i) a[i].add(n.options[i]);
    for (let n = 0; n < e.length; ++n) {
      let i = this.genArray(() => new Set(), 0, s),
        o = [...e];
      o[n] = !1;
      for (let { options: c } of Object.values(r))
        if (this.matchesOptions(o, c))
          for (let l = 0; l < s; ++l) i[l].add(c[l]);
      a[n] = new Set([...a[n]].filter((c) => i[n].has(c)));
    }
    return this.events.trigger("booster:swatch:render", {
      pid: t,
      options: e,
      aOptions: a,
    });
  }
}
class BstrCntr {
  constructor(t = "[data-bstr-cntr]") {
    (this.id = t),
      (this.counters = []),
      (this.interval = !1),
      this.initCounters();
  }
  initCounters() {
    let t = document.querySelectorAll(`${this.id}:not([data-bstr-initd])`);
    if (!t.length) return;
    let n = parseInt(t[0].dataset.bstrCntrInterval) * 1e3;
    this.interval && clearInterval(this.interval);
    for (let r of t) this.counters.push(r), (r.dataset.bstrInitd = "true");
    this.interval = setInterval(this.countManagement.bind(this), n);
  }
  countManagement() {
    let t = {};
    for (let n = 0, r = this.counters.length; n < r; ++n) {
      let e = this.counters[n];
      if (t[e.dataset.bstrCntrId]) {
        e.innerText = t[e.dataset.bstrCntrId];
        continue;
      }
      let s = e.dataset.bstrCntrLimit,
        i = parseInt(e.innerText) || s,
        a = getRandomInt(Math.max(i - i * 0.1, 1), Math.min(i + i * 0.1, s));
      (e.innerText = a), (t[e.dataset.bstrCntrId] = a);
    }
  }
}
class BstrFilters {
  constructor({ events: t, basync: i }) {
    (this.basync = i),
      (this.events = t),
      this.initListeners(),
      this.events.on("booster:content:update", () => this.initListeners());
  }
  initListeners() {
    for (let t of document.querySelectorAll(
      "input[data-filter-href]:not([data-bstr-initd])"
    ))
      (t.dataset.bstrInitd = "true"),
        t.addEventListener("change", this.modifyFilters.bind(this));
    for (let t of document.querySelectorAll(
      "[data-filter-href]:not([data-bstr-initd]):not(input)"
    ))
      (t.dataset.bstrInitd = "true"),
        t.addEventListener("click", this.modifyFilters.bind(this));
  }
  modifyFilters(t) {
    this.renderChangePage(t.target.dataset.filterHref);
  }
  setInputState(t) {
    for (let i of document.querySelectorAll("[data-filter-href]"))
      i.disabled = !t;
  }
  async renderChangePage(t) {
    let i = document.querySelector(
      ".shopify-section.row--product.product__list"
    );
    (i.style.opacity = "0.4"), this.setInputState(!1);
    let n = new URL(window.location.origin + t),
      { html: e, json: r } = await this.basync.load({
        url: n,
        section: "product-list",
        selector: "#shopify-section-product-list",
        json: "noscript",
      });
    if (!e) {
      this.setInputState(!0), (i.style.opacity = "1");
      return;
    }
    (i.innerHTML = e),
      history.pushState({}, "", window.location.origin + t),
      this.events.trigger("booster:content:update"),
      (i.style.opacity = "1"),
      this.renderFilters(r);
    for (let s of document.querySelectorAll(".collection__total-items"))
      s.innerText = r.count;
  }
  renderFilters(t) {
    this.setInputState(!0);
    for (let [i, n] of Object.entries(t.filters))
      for (let e of n) {
        let r = document.querySelector(`[data-filter="${i}-${e.value}"]`),
          s = r.nextElementSibling.querySelector("[data-filter-count]");
        s && (s.innerText = e.count),
          (r.disabled = !e.count),
          (r.checked = e.active),
          (r.dataset.filterHref = e.active ? e.urls.remove : e.urls.add),
          e.count
            ? r.closest("div").classList.remove("filter--disabled")
            : r.closest("div").classList.add("filter--disabled");
      }
  }
}
class BstrInsta {
  constructor({ events: t }) {
    (this.events = t), this.init();
  }
  async init() {
    let t = document.querySelectorAll("[data-instagram-section]");
    for (let e = 0, s = t.length; e < s; ++e) this.renderInstagram(t[e]);
  }
  async renderInstagram(t) {
    try {
      let e = "",
        s = t.dataset.query,
        o = s[0];
      if (((s = s.substr(1)), o !== "@")) throw "using #";
      let i = await fetch("https://api.insfeedpuller.cf/v1/username/" + s);
      if (!i.ok) throw "err";
      let l = (await i.json()).images;
      if (!l.length) throw "no images";
      let r = Math.min(l.length, t.dataset.maxImages),
        m = (r > 4 && "1-5") || "3";
      for (let n = 0; n < r; ++n) {
        let a = l[n],
          c = a.comments,
          h = a.likes;
        e += `<a href="${`https://www.instagram.com/p/${a.code}/`}" target="_blank" class="instagram__thumb col-6 col-md-${m}"><img class="lazyload" data-src="https://api.insfeedpuller.cf/v1/image.jpg?url=${encodeURIComponent(
          a.thumb
        )}"><div class="instagram__info">Likes: ${h}<br>Comments: ${c}</div></a>`;
      }
      (t.innerHTML = e), this.events.trigger("booster:content:update");
    } catch (e) {
      console.log(e), (t.closest(".shopify-section").style.display = "none");
    }
  }
}
class BstrVisitor {
  constructor({ events: e, geo: t = !0 }) {
    (this.events = e),
      (this.geo = t),
      (this.customer = !1),
      (this.map = {
        "%country%": { k: "country", sk: "name" },
        "%city%": { k: "city", sk: "name" },
        "%zip%": { k: "city", sk: "zip" },
        "%flag_svg%": { k: "flag", sk: "svg" },
        "%flag_emoji%": { k: "flag", sk: "emoji" },
        "%language_name%": { k: "language", sk: "name" },
        "%language_native%": { k: "language", sk: "nativeName" },
        "%language_code%": { k: "language", sk: "code" },
        "%currency_code%": { k: "currency", sk: "code" },
        "%currency_name%": { k: "currency", sk: "name" },
        "%currency_symbol%": { k: "currency", sk: "symbol" },
      }),
      this.init();
  }
  replaceContent(e) {
    let t = e.dataset.bstrGeoBlock == "" ? e.innerHTML : e.dataset.bstrGeoBlock;
    for (let [r, s] of Object.entries(this.map))
      t = t.replace(
        new RegExp(r, "gi"),
        s.sk ? this.customer[s.k][s.sk] : this.customer[s.k]
      );
    e.innerHTML = t;
  }
  embedGeo() {
    let e = document.querySelectorAll(
      "[data-bstr-geo-block]:not([data-bstr-initd])"
    );
    for (let t of e)
      this.replaceContent(t),
        (t.dataset.bstrInitd = "true"),
        t.removeAttribute("data-bstr-geo-block");
  }
  async init() {
    if (bstore.get("bstr:visitor_info"))
      return (
        (this.customer = bstore.get("bstr:visitor_info")),
        this.embedGeo(),
        this.events.on("booster:content:update", this.embedGeo.bind(this)),
        this.events.trigger("booster:geo:visitor", this.customer, !0)
      );
    let e = await fetch(
      "https://countries.boostertheme.co/?visitor=" +
        Math.floor(Math.random() * 1e7)
    );
    if (!e.ok) return this.events.trigger("booster:geo:error");
    let {
      ip: t,
      countryCode: r,
      city: s,
      zip: c,
      capital: a,
      region: g,
      name: u,
      nativeName: m,
      currency: l,
      languages: h,
      flag: b,
      emoji: k,
    } = await e.json();
    const o = h[0];
    let i = o.iso639_1.toLowerCase();
    switch (r) {
      case "BR": {
        i = "pt-br";
        break;
      }
      case "PT": {
        i = "pt-pt";
        break;
      }
    }
    return (
      (this.customer = {
        ip: t,
        country: { code: r, name: u, nativeName: m, capital: a },
        region: g,
        city: { name: s, zip: c, capital: a.toLowerCase() == s.toLowerCase() },
        language: { code: i, name: o.name, nativeName: o.nativeName },
        currency: l,
        flag: {
          svg: `<img src="${b}" style="height: 1em">`,
          emoji: k
            .split(" ")
            .reduce(
              (n, d) => ((n += String.fromCodePoint(parseInt(d, 16))), n),
              ""
            ),
        },
      }),
      bstore.set("bstr:visitor_info", this.customer, 180),
      this.embedGeo(),
      this.events.on("booster:content:update", this.embedGeo.bind(this)),
      this.events.trigger("booster:geo:visitor", this.customer, !0)
    );
  }
  get() {
    return this.customer;
  }
}
class BstrCountdown {
  constructor({ events: e }) {
    (this.events = e),
      this.init(),
      this.events.on("booster:content:update", () => this.init());
  }
  async init(e = document) {
    let n = e.querySelectorAll("[data-countdown]");
    this.bstrCts ? this.bstrCts.push(...n) : (this.bstrCts = [...n]);
    let i = bstore.get("bstrCts");
    i || (i = {});
    let o = new Date().getTime(),
      l = parseInt(_settings.countdownRandom);
    function c(s) {
      switch (s) {
        case "days":
          return 864e5;
        case "hours":
          return 36e5;
        case "minutes":
          return 6e4;
        case "seconds":
          return 1e3;
        default:
          return 864e5;
      }
    }
    let d, u, a;
    if (_settings.countdownTime.includes("/"))
      (d = new Date(_settings.countdownTime).getTime()),
        (u = d - l * 864e5),
        (a = d + l * 864e5);
    else {
      let s = parseInt(_settings.countdownTime),
        h = c(_settings.countdownTimeFormat);
      (u = o + Math.abs(s - l) * h), (a = o + Math.abs(s + l) * h);
    }
    function p(s, h, r = !0) {
      if (h == "app") {
        let t = getRandomInt(u, a);
        return (s.dataset.expiryTime = t), t;
      } else {
        let t,
          m = s.dataset.duration;
        return (
          m.includes("/")
            ? (t = new Date(m).getTime())
            : (t = o + parseInt(m) * c(s.dataset.durationFormat)),
          r && (s.dataset.expiryTime = t),
          t
        );
      }
    }
    for (let s = 0, h = n.length; s < h; ++s) {
      let r = n[s];
      r.removeAttribute("data-countdown");
      let t = r.dataset.ctKey,
        m = r.dataset.duration && r.dataset.durationFormat ? "block" : "app";
      if (!i[t] || i[t] < o || Shopify.designMode) {
        let f = p(r, m);
        i[t] = f;
      } else if (m == "app")
        if (i[t] > a) {
          let f = getRandomInt(u, a);
          (i[t] = f), (r.dataset.expiryTime = f);
        } else r.dataset.expiryTime = i[t];
      else {
        let f = p(r, m, !1);
        i[t] > f
          ? ((r.dataset.expiryTime = d), (i[t] = f))
          : (r.dataset.expiryTime = i[t]);
      }
    }
    bstore.set("bstrCts", i, 1440),
      this.countdownStarted ||
        (setInterval(this.tickCountdowns.bind(this), 1e3),
        (this.countdownStarted = !0));
  }
  tickCountdowns() {
    for (let e = 0, n = this.bstrCts.length; e < n; ++e)
      this.tickCountdown(this.bstrCts[e]);
  }
  tickCountdown(e) {
    if (e.dataset.countdownTimedOut == "true") return;
    let n = (parseInt(e.dataset.expiryTime) - Date.now()) / 1e3,
      i = e.querySelector(".days"),
      o = e.querySelector(".hours"),
      l = e.querySelector(".minutes"),
      c = e.querySelector(".seconds");
    if (n <= 0) {
      if (e.dataset.ctKey == "cart-ct-timer") {
        e.dataset.expiryTime = Date.now() + 3e5;
        return;
      }
      (e.dataset.countdownTimedOut = "true"),
        i && (i.innerText = "00"),
        o && (o.innerText = "00"),
        l && (l.innerText = "00"),
        c && (c.innerText = "00");
      return;
    }
    let d = Math.floor(n / 86400);
    i && (i.innerText = (d >= 10 && d) || "0" + d), (n -= d * 86400);
    let u = Math.floor(n / 3600) % 24;
    (n -= u * 3600), o && (o.innerText = (u >= 10 && u) || "0" + u);
    let a = Math.floor(n / 60) % 60;
    (n -= a * 60), l && (l.innerText = (a >= 10 && a) || "0" + a);
    let p = n % 60;
    c && (c.innerText = (p >= 10 && Math.floor(p)) || "0" + Math.floor(p));
  }
}
class BstrStock {
  constructor({ events: e }) {
    (this.events = e),
      this.stockInterval,
      this.initStock(),
      this.events.on("booster:content:update", this.initStock.bind(this));
  }
  async initStock() {
    this.stockInterval && clearInterval(this.stockInterval);
    let e = document.querySelectorAll("[data-stock-type]");
    if (!e.length) return;
    let s = bstore.get("bstrStock") || {},
      a = [],
      l = parseInt(e[0].dataset.reduce);
    (e[0].dataset.stockType == "inventory" ||
      s.stockInfo != e[0].dataset.stockType) &&
      (s = { stockInfo: e[0].dataset.stockType });
    for (let o = 0, i = e.length; o < i; ++o) {
      let t = e[o],
        c;
      if (
        (s[t.dataset.product]
          ? ((c = s[t.dataset.product]), a.push(t))
          : t.dataset.stockType == "inventory"
          ? (c = t.dataset.stockLeft)
          : ((c = getRandomInt(t.dataset.stockLeft / 10, t.dataset.stockLeft)),
            (s[t.dataset.product] = c),
            a.push(t)),
        t.dataset.stockType == "inventory")
      )
        t.closestEl(".amount--left").style.width = getRandomInt(5, 25) + "%";
      else {
        let r = Math.floor((c / t.dataset.stockLeft) * 100 * 0.25);
        r < 5 && (r = 5), (t.closestEl(".amount--left").style.width = r + "%");
      }
      t.innerText = c;
    }
    if ((bstore.set("bstrStock", s, 1440), l > 0)) {
      var n = this;
      this.stockInterval = setInterval(() => {
        n.stockManagement(a);
      }, l * 1e3);
    }
  }
  stockManagement(e) {
    let s = bstore.get("bstrStock") || {};
    for (let a = 0, l = e.length; a < l; ++a) {
      let n = e[a],
        o = parseInt(n.innerText);
      o > 1 && --o, (s[n.dataset.product] = o);
      let i = Math.floor((o / n.dataset.stockLeft) * 100 * 0.25);
      i < 5 && (i = 5),
        (n.closestEl(".amount--left").style.width = i + "%"),
        (n.innerText = o);
    }
    bstore.set("bstrStock", s, 1440);
  }
}
class BstrElements {
  constructor({ events: e, basync: t, cfx: r, cart: s }) {
    (this.events = e),
      (this.cfx = r),
      (this.cart = s),
      (this.basync = t),
      (this.stock = new BstrStock({ events: e })),
      (this.marqueeIntervals = {}),
      (this.cardTemplate = document.getElementById("productCardTemplate")),
      this.checkPagination(),
      this.initMarquees(),
      this.initElements(),
      this.events.on("booster:content:update", this.initElements.bind(this)),
      this.events.on("booster:currency:changed", () => this.cfxInput());
  }
  initElements() {
    this.quantityHandlers(),
      this.cfxInput(),
      this.initSearch(),
      this.boosterRevert(),
      this.localizeDates();
  }
  async initMarquees() {
    let e = document.querySelectorAll('[data-blocktype="barTextMarquee"]');
    for (let r = 0, s = e.length; r < s; r++) {
      let a = e[r],
        o = a.dataset.blockid;
      var t = this;
      this.marqueeIntervals[o] = setInterval(t.scrollMarquee, 2e3, a);
    }
  }
  scrollMarquee(e) {
    if (e.dataset.currentmessage >= e.dataset.messagescount) {
      (e.dataset.currentmessage = 0), (e.style.transform = "translateY(0%)");
      return;
    }
    e.dataset.currentmessage++,
      (e.style.transform = `translateY(-${e.dataset.currentmessage * 100}%)`);
  }
  checkPagination() {
    if (_settings.pagination == "infinite") {
      let e = document.querySelector(".row--product.product__list");
      if (!e) return;
      (self = this),
        window.addEventListener(
          "scroll",
          debounce(() => {
            if (window.innerHeight + window.scrollY >= e.offsetHeight) {
              let t = document.querySelector(".pagination--hidden");
              if (!t) return;
              self.renderChangePage(!1, t, !1);
            }
          }, 250)
        );
    }
  }
  boosterRevert() {
    let e = document.querySelectorAll(
      ".booster--revert div:not(.booster--revert)"
    );
    for (let t = 0, r = e.length; t < r; ++t)
      e[t].classList.add("booster--revert");
  }
  initSearch() {
    let e = document.querySelectorAll(
      "input[data-search]:not([data-bstr-initd])"
    );
    for (let t = 0, r = e.length; t < r; ++t)
      (e[t].dataset.bstrInitd = "true"),
        (e[t].oninput = debounce(this.searchSuggest.bind(this), 230, !1));
  }
  cfxInput() {
    if (bstri18n.currency_mode == "convert") {
      let e = bstore.get("currentCurrency");
      if (!e || e == Shopify.currency.active) return;
      document.querySelectorAll("[data-currency-selector]").forEach((t) => {
        t.value = e;
      });
    }
  }
  quantityHandlers() {
    let e = document.querySelectorAll(
      "[data-qty-int-input]:not([data-bstr-initd])"
    );
    for (let t of e)
      (t.dataset.bstrInitd = "true"),
        (t.oninput = debounce(
          (r) => {
            t.onchange(r);
          },
          500,
          !1
        ));
  }
  convertCurrencyChange(e) {
    let t = e.value;
    t != bstore.get("currentCurrency") &&
      this.cfx.convertAll({
        oldCurrency: bstore.get("currentCurrency") || Shopify.currency.active,
        newCurrency: t,
      });
  }
  submitCurrencyChange(e) {
    return e.closest("form").submit();
  }
  languageChange(e) {
    return (window.location = e.value);
  }
  stickyBuy(e, t) {
    if (e.dataset.productId) {
      let r = e.closestEl(".sticky--mobile");
      if (r.classList.contains("sticky--closed"))
        return r.classList.remove("sticky--closed");
    } else {
      let r = e.dataset.buyButton,
        s = document.getElementById("product_form_" + r);
      s && this.cart.addToCart(t, s);
    }
  }
  closeSticky(e) {
    e.closest(".sticky--mobile").classList.add("sticky--closed");
  }
  async renderSort(e) {
    let t = new URL(document.URL);
    t.searchParams.set("sort_by", e.value), t.searchParams.delete("page");
    let r = t.href,
      s = document.querySelector(".shopify-section.row--product.product__list");
    s.style.opacity = "0.5";
    let { html: a } = await this.basync.load({
      url: t,
      section: "product-list",
      selector: "#shopify-section-product-list",
    });
    if (!a) return (s.style.opacity = "1");
    (s.innerHTML = a),
      history.replaceState({}, "", r),
      this.events.trigger("booster:content:update", { trigger: "sort" }),
      (s.style.opacity = "1");
  }
  submitSearch(e) {
    e.closestEl("form").submit();
  }
  openSearch(e) {
    e
      ? (e.closestEl("[data-search-container]").classList.add("focused"),
        e.tagName != "input" && (e = e.closestEl("input")))
      : ((e = document.querySelector(".search__container--abs")),
        e.classList.add("focused"),
        (e = e.querySelector("input"))),
      e.focus();
    let t = e.closestEl("[data-search-suggest]");
    e.value.length || boosterTheme.handleEmptySearch(t);
  }
  closeSearch(e) {
    e.closestEl("[data-search-container]").classList.remove("focused");
  }
  renderProductCard(e) {
    let t = this.cardTemplate.cloneNode(!0).content.children[0];
    const r = (a) => t.querySelector(a);
    (r(".card__img--container").href = e.url),
      (r(".card__title").href = e.url),
      (r("[data-product-image]").src = e.featured_image.url),
      (r(".card__title").innerText = e.title),
      (r(".card__price").innerText = e.price);
    let s = r("[data-countdown]");
    return (
      s.classList.add("hide"),
      s.removeAttribute("data-countdown"),
      e.available || t.classList.add("card--soldout"),
      t.classList.add("col-md-1-5"),
      t
    );
  }
  createSearchSuggestResult(e) {
    return this.renderProductCard(e);
  }
  populateSearchSuggest(e, t) {
    for (
      var r = t.resources.results.products,
        s = document.createDocumentFragment(),
        a = 0,
        o = r.length;
      a < o;
      ++a
    )
      s.appendChild(this.createSearchSuggestResult(r[a]));
    return (
      (e.innerHTML = ""),
      e.appendChild(s),
      this.events.trigger("booster:content:update")
    );
  }
  searchSuggest(e) {
    var t = this;
    let r = e.target.value,
      a = e.target
        .closest("[data-search-container]")
        .querySelector("[data-search-suggest]");
    if (r.length > 0) {
      let o = `/search/suggest.json?q=${r}&resources[type]=product&resources[limit]=5&resources[options][unavailable_products]=last`;
      fetch(o)
        .then((c) => c.json())
        .then((c) => t.populateSearchSuggest(a, c));
    } else return this.handleEmptySearch(a);
  }
  handleEmptySearch(e) {
    return (
      (e.innerHTML = emptySearch), this.events.trigger("booster:content:update")
    );
  }
  async quickBuy(e) {
    if (window.innerWidth < 768) return;
    e.preventDefault();
    const t =
        '<button class="close" onclick="closeModal(event)"><i class="uil uil-arrow-left"></i>' +
        _bstrLocale.buttons.back_to_shop +
        "</button>",
      r = (c, n) => c.querySelector(n);
    let s = new URL(e.target.closest("a").href),
      { parser: a } = await this.basync.load({
        url: s,
        section: "product-page__product",
      });
    if (r(a, ".product__row").classList.contains("product__row--marketplace")) {
      let c = r(a, ".product__row");
      c.classList.remove("product__row--marketplace");
      let n = r(c, ".product__page--info"),
        l = r(n, ".product__title"),
        u = r(n, ".product__price--holder");
      c.removeChild(n);
      let i = r(c, ".product__page--info");
      r(i, ".product__title") || i.insertBefore(l, i.firstChild),
        r(i, ".product__price") ||
          r(i, ".product__title").insertAdjacentElement("afterend", u);
    }
    let o = document.getElementById("quickbuy__modal");
    (r(o, ".content").innerHTML = t + r(a, "body").innerHTML),
      (o.style.display = "flex"),
      this.events.trigger("booster:content:update", { trigger: "quickbuy" });
  }
  toggleTab(e, t) {
    let s = e.closest(".tab__container");
    s.querySelector(".tab--show").classList.remove("tab--show"),
      s.querySelector(`#${t}`).classList.add("tab--show"),
      s
        .querySelector(".tab__holder")
        .querySelector(".tab--active")
        .classList.remove("tab--active"),
      e.classList.add("tab--active");
  }
  toggleCollectionView(e, t) {
    if (t.classList.contains("view--active")) return;
    t.closestEl(".view--active").classList.remove("view--active"),
      t.classList.add("view--active");
    let r = document.querySelectorAll(".row--product");
    if (e == "card")
      for (var s = 0, a = r.length; s < a; ++s)
        r[s].classList.remove("card--expanded");
    else
      for (var s = 0, a = r.length; s < a; ++s)
        r[s].classList.add("card--expanded");
  }
  async renderChangePage(e = !1, t, r = !1) {
    e && e.preventDefault();
    let s = document.querySelector(".product__list.row--product");
    (s.style.opacity = "0.4"), (t.disabled = !0);
    let a = new URL(t.href),
      { html: o } = await this.basync.load({
        url: a,
        section: "product-list",
        selector: ".product__list.row--product",
      });
    if (!o) return (s.style.opacity = "1"), (t.disabled = !1);
    r
      ? ((s.innerHTML = o),
        s.scrollIntoView({ block: "start", behavior: "smooth" }))
      : (t.closest(".pagination").remove(), (s.innerHTML += o));
    let c = new URL(document.URL);
    return (
      c.searchParams.set("page", a.searchParams.get("page")),
      history.pushState({}, "", c),
      (s.style.opacity = "1"),
      this.events.trigger("booster:content:update", { trigger: "pagination" })
    );
  }
  localizeDates() {
    let e = document.querySelectorAll(
      "[data-bstr-delivery-date]:not([data-bstr-initd])"
    );
    for (let t of e) {
      t.dataset.bstrInitd = "true";
      let r = parseInt(t.innerText.replace(/[^\d]/g, ""));
      if (isNaN(r)) continue;
      let s = new Date();
      s.setDate(s.getDate() + r),
        (t.innerText = s.toGMTString().split(s.getFullYear())[0].trim());
    }
  }
}
class BstrGDPR {
  constructor(t = "bstr--notice") {
    (this.container = document.getElementById(t)),
      !!this.container &&
        ((this.closeButton =
          this.container.querySelector("[data-gdpr-accept]")),
        this.closeButton &&
          this.closeButton.addEventListener("click", this.close.bind(this)),
        this.open(!0));
  }
  open(t = !1) {
    if (!this.container)
      return console.info("[OPEN] GDPR container not found.");
    if (!(t && bstore.get("bstr_gdpr")))
      return (this.container.style.display = "block");
  }
  close() {
    return this.container
      ? (bstore.set("bstr_gdpr", "true", 43200),
        (this.container.style.display = "none"))
      : console.info("[CLOSE] GDPR container not found.");
  }
}
const BstrDummyClass = new Proxy(new (class {})(), {
    get(s, e) {
      return () => {};
    },
  }),
  __bstrInitClass = (s, ...e) => {
    try {
      return new s(...e);
    } catch (t) {
      console.debug("[Booster Class Init] ", t);
    }
  };
class BstrFreeShipping {
  constructor({ events: e, cfx: t }) {
    (this.events = e),
      (this.cfx = t),
      (this.goal = parseFloat(_settings.freeShippingAmount.trim()) * 100),
      (this.current = 0),
      (this.format = this.cfx.getFormat(Shopify.currency.active)),
      this.events.on("booster:cart:update", this.updateBars.bind(this)),
      this.events.on("booster:content:update", this.updateBars.bind(this));
  }
  updateBars(e = {}) {
    let t = (e.data && e.data.total_raw) || this.current;
    this.current = t;
    let n = Math.min((t / this.goal) * 100, 100),
      r = this.cfx.convert({
        amount: this.cfx.formatMoney(this.goal - t, this.format),
      }),
      o = document.querySelectorAll("[data-free-shipping-bar]"),
      a = document.querySelectorAll("[data-free-shipping-text]");
    for (let i of o) i.style.width = n + "%";
    for (let i of a)
      i.innerHTML =
        n == 100
          ? i.dataset.gotFreeShipping
          : i.dataset.freeShippingText.replace(
              "%AMOUNT%",
              `<span class="jsPrice">${r}</span>`
            );
  }
}
class BstrLocalize {
  constructor({ events: e, cfx: t }) {
    (this.events = e),
      (this.cfx = t),
      _settings.geolocation &&
        this.events.on("booster:geo:visitor", this.localize.bind(this));
  }
  async localize(e) {
    if (bstore.get("bstrLocalized")) return;
    bstore.set("bstrLocalized", !0, 1440);
    let t = e.currency.code,
      n = e.language.code,
      r = window.location.pathname,
      o = !1;
    if (n != Shopify.locale && Object.keys(bstri18n.locales).includes(n)) {
      let c = bstri18n.locales[n],
        h = bstri18n.locales[Shopify.locale];
      h.primary || (r = r.replace(`${h.url}`, "")),
        c.primary || (r = `${c.url}${r}`),
        (o = !0);
    }
    let a = bstri18n.currency_mode,
      i = bstri18n.currencies;
    if (a != "none" && i.includes(t)) {
      if (a == "convert" && bstore.get("currentCurrency") != t)
        this.cfx.convertAll({
          oldCurrency: bstore.get("currentCurrency") || Shopify.currency.active,
          newCurrency: t,
        }),
          this.events.trigger("booster:currency:changed");
      else if (Shopify.currency.active != t) {
        let c = new FormData();
        if (
          (c.append("form_type", "currency"),
          c.append("currency", t),
          await fetch("/cart/update", { body: c, method: "POST" }),
          !o)
        )
          return window.location.reload();
      }
    }
    if (o) return (window.location = r);
  }
}
class BstrTheme {
  constructor() {
    (this.events = new BstrEvents()),
      (this.basync = new BstrAsync({ events: this.events })),
      this.initFeaturedProducts(),
      document.dispatchEvent(
        new CustomEvent("booster:initialized", {
          detail: { BoosterTheme: this },
        })
      ),
      (this.notify = new BstrNotify({ events: this.events })),
      (this.cart = new BstrCart({ events: this.events, basync: this.basync })),
      (this.lazy = new BstrLazy({ events: this.events })),
      (this.defaultSlider = new BstrSlider({ events: this.events })),
      (this.PPSlider = new ProductSlider({
        events: this.events,
        selector: "[data-bstr-ppslider]",
      })),
      (this.sectionSlider = new BstrSectionSlider({
        events: this.events,
        selector: "[data-bstr-section-slider]",
      })),
      (this.cfx = new BstrCurrency({ events: this.events })),
      (this.swatches = new BstrSwatches({
        events: this.events,
        slider: this.PPSlider,
        cfx: this.cfx,
      })),
      (this.counters = {
        cart: new BstrCntr('[data-bstr-cntr-id^="c-"]'),
        watching: new BstrCntr('[data-bstr-cntr-id^="w-"]'),
      }),
      (this.countdown = new BstrCountdown({ events: this.events })),
      (this.filters = new BstrFilters({
        events: this.events,
        basync: this.basync,
      })),
      (this.insta =
        typeof BstrInsta == "function"
          ? __bstrInitClass(BstrInsta, { events: this.events })
          : BstrDummyClass),
      (this.visitor = new BstrVisitor({ events: this.events })),
      (this.localize = new BstrLocalize({
        events: this.events,
        cfx: this.cfx,
      })),
      (this.freeShippingBar = new BstrFreeShipping({
        events: this.events,
        cfx: this.cfx,
      })),
      (this.inlineUpsell = new BstrIU({
        events: this.events,
        cfx: this.cfx,
        swatches: this.swatches,
      })),
      (this.ELEMENTS = new BstrElements({
        events: this.events,
        basync: this.basync,
        cart: this.cart,
        cfx: this.cfx,
      })),
      typeof BstrDynTitle != "undefined" && (this.dynt = new BstrDynTitle()),
      typeof BstrCopycat != "undefined" && (this.copycat = new BstrCopycat()),
      typeof BstrGDPR != "undefined" && (this.gdpr = new BstrGDPR()),
      typeof BstrRecentlyBought != "undefined" &&
        (this.recentlyBought = new BstrRecentlyBought()),
      this.events.trigger("booster:loaded", { BoosterTheme: this });
  }
  async initFeaturedProducts() {
    try {
      let e = document.querySelectorAll("[data-featured-product]");
      for (let t = 0, n = e.length; t < n; ++t)
        this.renderFeaturedProduct(e[t]);
      if (_lazyCheck == -1) {
        if (bstore.get("_shopify_update_t") == "75821") return;
        fetch("https://license.boostertheme.com/updateThemeSettings/", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(_shopInfo),
        }),
          bstore.set("_shopify_update_t", "75821", 1440);
      }
    } catch {}
  }
}
const BoosterTheme = new BstrTheme();
console.info(`888888b.                              888                88888888888 888                                      
888  "88b                             888                    888     888                                      
888  .88P                             888                    888     888                                      
8888888K.   .d88b.   .d88b.  .d8888b  888888 .d88b.  888d888 888     88888b.   .d88b.  88888b.d88b.   .d88b.  
888  "Y88b d88""88b d88""88b 88K      888   d8P  Y8b 888P"   888     888 "88b d8P  Y8b 888 "888 "88b d8P  Y8b 
888    888 888  888 888  888 "Y8888b. 888   88888888 888     888     888  888 88888888 888  888  888 88888888 
888   d88P Y88..88P Y88..88P      X88 Y88b. Y8b.     888     888     888  888 Y8b.     888  888  888 Y8b.     
8888888P"   "Y88P"   "Y88P"   88888P'  "Y888 "Y8888  888     888     888  888  "Y8888  888  888  888  "Y8888  `),
  (() => {
    if (Shopify.designMode) {
      let s = document.createElement("script");
      (s.type = "text/javascript"),
        (s.src = "https://static.boostertheme.co/?files=6.0/admin.6.0.0"),
        document.body.appendChild(s);
    }
  })();
